import { MappingsItemSettings, MappingsOutput } from './../mappings.model';
import { Injectable, OnDestroy  } from '@angular/core';
import { MappingsService } from '../mappings.service';
import { NavController } from '@ionic/angular';
import { MathHelperService } from 'src/app/nav-driver/vision-web/math-helper.service';
import {
  ActionFilterClass,
  BinaryEvent,
  MappingsOutputType,
  MovementSource,
} from '../mappings.model';
import { VoiceService } from 'src/app/voice/voice.service';
// import {mean,
//   median,
//   mode,
//   minimum,
//   maximum,
//   range,
//   standardDeviation} from 'array-statistics';

export interface MovementParameters {
  fsmState?: any;
  max?: number;
  min?: number;
  center?: number;
  speed?: number;
  responseTime?: number;
  precision?: number;
  intentionality?: boolean;
  resolution: number;
  tested: 'untested' | 'binary' | 'digital' | 'fail' | 'unable';
  highThreshold?: number;
  lowThreshold?: number;
  movement?: string;
  score?: number;
  allocation?: string;
}

export interface MovementTestResults {
  // HEAD
  headRoll: MovementParameters; // Tombar para os ombros
  headPitch: MovementParameters; // Rotação SIM
  headYaw: MovementParameters; // Rotação NÃO
  // EYES
  leftBlink: MovementParameters;
  rightBlink: MovementParameters;
  leftRightBlink: MovementParameters;
  eyeGazeUp: MovementParameters;
  eyeGazeDown: MovementParameters;
  eyeGazeLeft: MovementParameters;
  eyeGazeRight: MovementParameters;
  eyeGazeHorizontal: MovementParameters;
  eyeGazeVertical: MovementParameters;
  // EYEBROWS ?
  // MOUTH
  mouthOpen: MovementParameters;
  smile: MovementParameters;
  kiss: MovementParameters;
  kissRight: MovementParameters;
  kissLeft: MovementParameters;
}

@Injectable({
  providedIn: 'root',
})
export class MappingsWizardService {
  results: MovementTestResults;

  currentTest: string; // Só pode receber nome das chaves definidas na interface MovementTestResults!!!

  // Main temporary parameters for current FSM control and calculations
  currentParameters: MovementParameters;
  // Auxiliary temporary parameters for current FSM control and calculations
  currentParametersB: MovementParameters;
  currentParametersC: MovementParameters;

  wizardTempMappingIndex: number;

  secondaryWizardMappings: Array<number>;

  samplingInterval;

  eventSubscription;

  output: number;

  target: number;

  capturing: boolean;

  resolution: number;

  commandText: string;

  gazeTarget: { x: number; y: number }; // Coordinates to position eye gaze target

  sampleArray: Array<number>;

  timestamp1: number;

  userMappingsTempMemory;

  floatingTarget: { x: number; y: number };

  arrow: number;

  tipImagePath: string;

  onImage = false;

  videoElement;

  suggestedMappings = new Array<MappingsItemSettings>();

  lastEvents: {
    leftBlink: { detected: boolean; timestamp: number };
    rightBlink: { detected: boolean; timestamp: number };
    leftRightBlink: { detected: boolean; timestamp: number };

    eyeGazeUp: { detected: boolean; timestamp: number };
    eyeGazeDown: { detected: boolean; timestamp: number };
    eyeGazeLeft: { detected: boolean; timestamp: number };
    eyeGazeRight: { detected: boolean; timestamp: number };

    headPointingAway: { detected: boolean; timestamp: number };
  };

  compiledResults: {
    digitalInputs: number;
    bestCursorH: MovementTestResults;
    bestCursorV: MovementTestResults;
    bestSelector: MovementTestResults;
    bestCancel: MovementTestResults;
    bestShortcuts: MovementTestResults;
  };

  headCommands = {
    center1: {
      headRoll: 'Centralize sua cabeça e permaneça parado',
      headPitch: 'Centralize sua cabeça e permaneça parado',
      headYaw: 'Centralize sua cabeça e permaneça parado',
    },
    max: {
      headRoll: 'Incline sua cabeça confortavelmente para a direita',
      headPitch: 'Gire sua cabeça confortavelmente para baixo',
      headYaw: 'Gire sua cabeça confortavelmente para a direita',
    },
    center2: {
      headRoll: 'Centralize sua cabeça e permaneça parado',
      headPitch: 'Centralize sua cabeça e permaneça parado',
      headYaw: 'Centralize sua cabeça e permaneça parado',
    },
    min: {
      headRoll: 'Incline sua cabeça confortavelmente para a esquerda',
      headPitch: 'Gire sua cabeça confortavelmente para cima',
      headYaw: 'Gire sua cabeça confortavelmente para a esquerda',
    },
  };

  headImages = {
    center1: {
      headRoll: '/assets/images/MP4/cabeça04GirarEsqCentro.mp4',
      headPitch: '/assets/images/MP4/cabeça04GirarEsqCentro.mp4',
      headYaw: '/assets/images/MP4/cabeça04GirarEsqCentro.mp4',
    },
    max: {
      headRoll:  '/assets/images/MP4/cabeça09InclinarCentroDir.mp4',
      headPitch: '/assets/images/MP4/cabeça07GirarCentroBaixo.mp4',
      headYaw: '/assets/images/MP4/cabeça01GirarCentroDir.mp4',
    },
    center2: {
      headRoll: '/assets/images/MP4/cabeça04GirarEsqCentro.mp4',
      headPitch: '/assets/images/MP4/cabeça04GirarEsqCentro.mp4',
      headYaw: '/assets/images/MP4/cabeça04GirarEsqCentro.mp4',
    },
    min: {
      headRoll: '/assets/images/MP4/cabeça11InclinarCentroEsq.mp4',
      headPitch: '/assets/images/MP4/cabeça05GirarCentroCima.mp4',
      headYaw: '/assets/images/MP4/cabeça03GirarCentroEsq.mp4',
    },
  };

  mouthCommands = {
    max: {
      mouthOpen: 'Abra bem a boca',
      smile: 'Abra um grande sorriso',
      kiss: 'Faça um beijo bem forte',
    },
    center: {
      mouthOpen: 'Diminua a abertura pela metade',
      smile: 'Reduza o sorrizo pela metade',
      kiss: 'Agora um beijo mais sutil',
    },
    min: {
      mouthOpen: 'Agora mantenha a boca fechada',
      smile: 'Agora volte para a posição relaxada',
      kiss: 'Agora volte para a posição relaxada',
    },
  };

  mouthImages = {
    max: {
      mouthOpen: '/assets/images/MP4/boca13Abrir.mp4',
      smile: '/assets/images/MP4/boca15AbrirSorriso.mp4',
      kiss: '/assets/images/MP4/boca17FazerBeijo.mp4',
    },
    center: {
      mouthOpen: '/assets/images/MP4/boca14Fechar.mp4',
      smile: '/assets/images/MP4/boca16FecharSorriso.mp4',
      kiss: '/assets/images/MP4/boca17FazerBeijo.mp4',
    },
    min: {
      mouthOpen: '/assets/images/MP4/boca14Fechar.mp4',
      smile: '/assets/images/MP4/boca16FecharSorriso.mp4',
      kiss: '/assets/images/MP4/boca18DesfazerBeijo.mp4',
    },
  };

  eyeGazeCommands = {
    prepare: {
      eyeGazeHorizontal:
        'Mantenha a cabeça centralizada. Movimente apenas seus olhos!',
      eyeGazeVertical:
        'Mantenha a cabeça centralizada. Movimente apenas seus olhos!',
    },
    max1: {
      eyeGazeHorizontal: 'Olhe o máximo para direita',
      eyeGazeVertical: 'Olhe o máximo para baixo',
    },
    center: {
      eyeGazeHorizontal: 'Olhe para o ponto vermelho no centro da tela',
      eyeGazeVertical: 'Olhe para o ponto vermelho no centro da tela',
    },
    min1: {
      eyeGazeHorizontal: 'Olhe o máxímo para a esquerda',
      eyeGazeVertical: 'Olhe o máxímo para cima',
    },
    screenBorder: {
      eyeGazeHorizontal: 'Siga a bolinha com o olhar',
      eyeGazeVertical: 'Siga a bolinha com o olhar',
    },
    lowerThreshold: {
      eyeGazeHorizontal: 'Olhe para o novo alvo',
      eyeGazeVertical: 'Olhe para o novo alvo',
    },
    follow: {
      eyeGazeHorizontal: 'Siga a bolinha com o olhar',
      eyeGazeVertical: 'Siga a bolinha com o olhar',
    },
    max2: {
      eyeGazeHorizontal: 'Olhe o máximo para direita sem mover a cabeça',
      eyeGazeVertical: 'Olhe o máximo para baixo sem mover a cabeça',
    },
    min2: {
      eyeGazeHorizontal: 'Olhe o máxímo para a esquerda sem mover a cabeça',
      eyeGazeVertical: 'Olhe o máxímo para cima sem mover a cabeça',
    },
  };

   // '/assets/images/movesGif/boca18DesfazerBeijo.gif'
   eyeGazeImage = {
    max1: {
      eyeGazeHorizontal: '/assets/images/MP4/olhos22OlharDir.mp4',
      eyeGazeVertical: '/assets/images/MP4/olhos20OlharBaixo.mp4',
    },
    min1: {
      eyeGazeHorizontal: '/assets/images/MP4/piscar23Esq.mp4',
      eyeGazeVertical: '/assets/images/MP4/olhos19OlharCima.mp4',
    },
    max2: {
      eyeGazeHorizontal: '/assets/images/MP4/olhos22OlharDir.mp4',
      eyeGazeVertical: '/assets/images/MP4/olhos20OlharBaixo.mp4',
    },
    min2: {
      eyeGazeHorizontal: '/assets/images/MP4/olhos22OlharEsq.mp4',
      eyeGazeVertical: '/assets/images/MP4/olhos19OlharCima.mp4',
    },
  };

  // Handle for the timeout that navigates back after test ends
  testEndedNavigationTimeout;

  constructor(
    private mappings: MappingsService,
    private voice: VoiceService,
    private navCtrl: NavController,
    private mathHelper: MathHelperService,
    //ublic renderer: Renderer2,
  ) {
    this.results = {} as MovementTestResults;

    console.log(this.results);

    this.results.headRoll = {
      tested: 'untested',
      resolution: 7,
      movement: 'headRoll',
    };
    this.results.headPitch = {
      tested: 'untested',
      resolution: 7,
      movement: 'headPitch',
    };
    this.results.headYaw = {
      tested: 'untested',
      resolution: 7,
      movement: 'headYaw',
    };
    // EYES
    this.results.leftBlink = {
      tested: 'untested',
      resolution: 2,
      movement: 'leftBlink',
    };
    this.results.rightBlink = {
      tested: 'untested',
      resolution: 2,
      movement: 'rightBlink',
    };
    this.results.leftRightBlink = {
      tested: 'untested',
      resolution: 2,
      movement: 'leftRightBlink',
    };
    this.results.eyeGazeUp = {
      tested: 'untested',
      resolution: 2,
      movement: 'eyeGazeUp',
    };
    this.results.eyeGazeDown = {
      tested: 'untested',
      resolution: 2,
      movement: 'eyeGazeDown',
    };
    this.results.eyeGazeLeft = {
      tested: 'untested',
      resolution: 2,
      movement: 'eyeGazeLeft',
    };
    this.results.eyeGazeRight = {
      tested: 'untested',
      resolution: 2,
      movement: 'eyeGazeRight',
    };
    this.results.eyeGazeHorizontal = {
      tested: 'untested',
      resolution: 5,
      movement: 'eyeGazeHorizontal',
    };
    this.results.eyeGazeVertical = {
      tested: 'untested',
      resolution: 5,
      movement: 'eyeGazeVertical',
    };
    // EYEBROWS ?
    // MOUTH
    this.results.mouthOpen = {
      tested: 'untested',
      resolution: 7,
      movement: 'mouthOpen',
    };
    this.results.smile = {
      tested: 'untested',
      resolution: 3,
      movement: 'smile',
    };
    this.results.kiss = { tested: 'untested', resolution: 3, movement: 'kiss' };
    this.results.kissRight = {
      tested: 'untested',
      resolution: 3,
      movement: 'kissRight',
    };
    this.results.kissLeft = {
      tested: 'untested',
      resolution: 3,
      movement: 'kissLeft',
    };

    this.output = 0.5;
    this.capturing = false;
    this.resolution = 10;

    this.lastEvents = {
      leftBlink: { detected: false, timestamp: 0 },
      rightBlink: { detected: false, timestamp: 0 },
      leftRightBlink: { detected: false, timestamp: 0 },

      eyeGazeUp: { detected: false, timestamp: 0 },
      eyeGazeDown: { detected: false, timestamp: 0 },
      eyeGazeLeft: { detected: false, timestamp: 0 },
      eyeGazeRight: { detected: false, timestamp: 0 },

      headPointingAway: { detected: false, timestamp: 0 },
    };

    this.compiledResults = {
      digitalInputs: 0,
      bestCursorH: undefined,
      bestCancel: undefined,
      bestCursorV: undefined,
      bestSelector: undefined,
      bestShortcuts: undefined,
    };

    // this.registerTempWizardMapping();
    // this.samplingInterval = setInterval(() => this.sampleCallback(), 100);
    // this.eventSubscription = this.mappings.binaryEventBS.subscribe((value) => this.eventCallback(value));
  }

  updateVideoElement() {
    const videoElement = document.getElementById('myVideo') as HTMLVideoElement;
    videoElement.load();
  }

  onDestroy() {
    this.removeTempWizardMapping();
    clearInterval(this.samplingInterval);
  }

  sampleCallback() {
    if (this.wizardTempMappingIndex === undefined) {
      return;
    }
    this.output = this.mappings.normalizeRange(
      this.results[this.currentTest]?.min || 0,
      this.mappings.state.mappings[this.wizardTempMappingIndex]
        ?.detectionLevel || this.output,
      this.results[this.currentTest]?.max || 1
    );

    if (this.currentParameters?.fsmState) {
      this.headRotationTestFsm();
      this.faceMouthTestFsm();
      this.faceEyeGazeTestFsm();
      this.faceEyeBlinkTestFsm();
    }
  }

  eventCallback(ev: MappingsOutput) {
    // if (
    //   ev.type === MappingsOutputType.wizardEvent &&
    //   ev.data in this.lastEvents
    // ) {
    //   this.lastEvents[ev.data].timestamp = Date.now();
    //   this.lastEvents[ev.data].detected = ev.detected;
    //   console.log(this.lastEvents);
    // } else {
    //   console.log('eventCallback name not found', ev);
    // }
  }

  startWizardMode() {
    this.disableUserMappings();
    this.registerTempWizardMapping();
    // this.eventSubscription = this.mappings.binaryEventBS.subscribe((value) =>
    //   this.eventCallback(value)
    // );
  }

  leaveWizardMode() {
    this.removeTempWizardMapping();
    this.enableUserMappings();
    this.eventSubscription?.unsubscribe();
  }

  registerTempWizardMapping() {
    clearInterval(this.samplingInterval);
    this.eventSubscription?.unsubscribe();

    this.samplingInterval = setInterval(() => this.sampleCallback(), 100);
    // this.eventSubscription = this.mappings.binaryEventBS.subscribe((value) =>
    //   this.eventCallback(value)
    // );

    this.wizardTempMappingIndex = this.mappings.createMapping();
    this.mappings.settings.mappings[this.wizardTempMappingIndex].name =
      'mappings-wizard';
    this.mappings.settings.mappings[
      this.wizardTempMappingIndex
    ].detectionAction.filterClass = ActionFilterClass.calibration;
    console.log(
      '[mappings-wizard][registerTempWizardMapping]',
      this.wizardTempMappingIndex
    );
    this.secondaryWizardMappings = [];
    this.secondaryWizardMappings.push(this.mappings.createMapping());
    this.secondaryWizardMappings.push(this.mappings.createMapping());
    this.secondaryWizardMappings.push(this.mappings.createMapping());
    this.secondaryWizardMappings.push(this.mappings.createMapping());
    this.secondaryWizardMappings.forEach((element) => {
      this.mappings.settings.mappings[element].name = 'mappings-wizard';
      this.mappings.settings.mappings[element].detectionAction.filterClass =
        ActionFilterClass.calibration;
      console.log('[mappings-wizard][registerTempWizardMapping]', element);
    });
  }

  removeTempWizardMapping() {
    clearInterval(this.samplingInterval);
    this.eventSubscription?.unsubscribe();

    this.mappings.removeMapping(this.wizardTempMappingIndex);
    this.secondaryWizardMappings.forEach((element) => {
      this.mappings.removeMapping(element);
    });
    this.secondaryWizardMappings = [];
  }

  // TODO: Salvar apenas os que foram desligados para religar depois
  disableUserMappings() {
    this.mappings.settings.mappings.forEach((mapping) => {
      if (mapping.name !== 'mappings-wizard' && mapping.enabled) {
        mapping.enabled = false;
      }
    });
  }

  enableUserMappings() {
    this.mappings.settings.mappings.forEach((mapping) => {
      if (mapping.name !== 'mappings-wizard' && mapping.enabled) {
        mapping.enabled = true;
      }
    });
  }

  /**
   * @abstract Resposible for clean test exit. Sould be called when FSM decides to end test or user event exits page
   */
  endCurrentTest(exitTestPage: boolean = false) {
    if (this.currentTest) {
      this.currentParameters.fsmState = undefined;
      this.compileResults();
      if (this.testEndedNavigationTimeout) {
        clearInterval(this.testEndedNavigationTimeout);
      }
      if (exitTestPage) {
        setTimeout(() => {
          this.voice.speakSystem('teste concluído com sucesso');
        }, 2000);
        this.testEndedNavigationTimeout = setTimeout(() => {
          this.navCtrl.pop();
        }, 5000);
      }
    }
  }

  currentParametersDefault(): MovementParameters {
    return {
      resolution: this.results[this.currentTest].resolution, // Mantem valor inicializado
      movement: this.results[this.currentTest].movement, // Mantem valor inicializado
      tested: 'fail',
      max: 1,
      min: 0,
      center: 0.5,
      score: 1,
      responseTime: 0,
      fsmState: 'start',
    };
  }

  resetVisualization() {
    this.target = undefined;
    this.output = 0.5;
    this.capturing = false;
    this.floatingTarget = undefined;
    this.arrow = undefined;
  }

  timerStart() {
    this.timestamp1 = Date.now();
  }

  timerExceeds(millis: number) {
    if (this.timestamp1) {
      return Date.now() - this.timestamp1 > millis;
    }
    return false;
  }

  timerClear() {
    this.timestamp1 = undefined;
  }

  discretize(value: number, resolution: number): number {
    return Math.floor(value * (resolution - 1) + 0.5) / (resolution - 1);
  }

  // https://github.com/30-seconds/30-seconds-of-code
  standardDeviation(arr, usePopulation = false) {
    const mean = arr.reduce((acc, val) => acc + val, 0) / arr.length;
    return Math.sqrt(
      arr
        .reduce((acc, val) => acc.concat((val - mean) ** 2), [])
        .reduce((acc, val) => acc + val, 0) /
        (arr.length - (usePopulation ? 0 : 1))
    );
  }

  compileResults() {
    let countH = 0;
    let countV = 0;
    this.compiledResults.digitalInputs = 0;
    for (const item in this.results) {
      if (Object.prototype.hasOwnProperty.call(this.results, item)) {
        const result = this.results[item] as MovementParameters;
        // Count available digital sources
        if (result.tested === 'digital') {
          if(item === 'headYaw' || item === 'headRoll') {
            countH++;
          }
          else if (item === 'headPitch' || item === 'mouthOpen') {
            countV++;
          }
          // this.compiledResults.digitalInputs++;
        }
        // Compute a score for each movement
        else if (result.tested === 'binary') {

        }
      }
    }

    if(countH) {
      this.compiledResults.digitalInputs++;
    }
    if(countV) {
      this.compiledResults.digitalInputs++;
    }

    console.log(
      '[mappings-wizard][compileResults]',
      this.compiledResults,
      this.currentParameters,
      this.results
    );
  }
  ///////////////////////////
  // Test functions
  ///////////////////////////

  startHeadRollTestFSM() {
    this.disableUserMappings();
    this.currentTest = 'headRoll';
    this.currentParameters = this.currentParametersDefault();
    this.resolution = this.results.headRoll.resolution;
    this.mappings.settings.mappings[this.wizardTempMappingIndex].movement = {
      name: 'head roll',
      function: 'findRoll',
      source: MovementSource.face,
    };
    this.mappings.settings.mappings[
      this.wizardTempMappingIndex
    ].detectionAction = { name: 'calibration', function: 'actionCalibration' };
    this.mappings.settings.mappings[
      this.wizardTempMappingIndex
    ].hysteresis = 0.03;
    this.resetVisualization();
  }

  startHeadPitchTestFSM() {
    this.disableUserMappings();
    console.log('startHeadPitchTestFSM', this.currentTest);
    this.currentTest = 'headPitch';
    this.currentParameters = this.currentParametersDefault();
    this.resolution = this.results.headPitch.resolution;
    this.mappings.settings.mappings[this.wizardTempMappingIndex].movement = {
      name: 'head pitch',
      function: 'findPitch',
      source: MovementSource.face,
    };
    this.mappings.settings.mappings[
      this.wizardTempMappingIndex
    ].detectionAction = { name: 'calibration', function: 'actionCalibration' };
    this.mappings.settings.mappings[
      this.wizardTempMappingIndex
    ].hysteresis = 0.03;
    this.resetVisualization();
  }

  startHeadYawTestFSM() {
    this.disableUserMappings();
    this.currentTest = 'headYaw';
    this.currentParameters = this.currentParametersDefault();
    this.resolution = this.results.headYaw.resolution;
    this.mappings.settings.mappings[this.wizardTempMappingIndex].movement = {
      name: 'head yaw',
      function: 'findYaw',
      source: MovementSource.face,
    };
    this.mappings.settings.mappings[
      this.wizardTempMappingIndex
    ].detectionAction = { name: 'calibration', function: 'actionCalibration' };
    this.mappings.settings.mappings[
      this.wizardTempMappingIndex
    ].hysteresis = 0.03;
    this.resetVisualization();
  }

  startMouthOpenTestFSM() {
    console.log('startMouthOpenTestFSM');
    this.disableUserMappings();
    this.currentTest = 'mouthOpen';
    this.currentParameters = this.currentParametersDefault();
    this.resolution = this.results.mouthOpen.resolution;
    this.mappings.settings.mappings[this.wizardTempMappingIndex].movement = {
      name: 'mouthOpen',
      function: 'findMouthOpen',
      source: MovementSource.face,
    };
    this.mappings.settings.mappings[
      this.wizardTempMappingIndex
    ].detectionAction = { name: 'calibration', function: 'actionCalibration' };
    this.mappings.settings.mappings[
      this.wizardTempMappingIndex
    ].hysteresis = 0.05;
    this.resetVisualization();
  }

  startSmileTestFSM() {
    this.disableUserMappings();
    this.currentTest = 'smile';
    this.currentParameters = this.currentParametersDefault();
    this.resolution = this.results.smile.resolution;
    this.mappings.settings.mappings[this.wizardTempMappingIndex].movement = {
      name: 'smile',
      function: 'findSmile',
      source: MovementSource.face,
    };
    this.mappings.settings.mappings[
      this.wizardTempMappingIndex
    ].detectionAction = { name: 'calibration', function: 'actionCalibration' };
    this.mappings.settings.mappings[
      this.wizardTempMappingIndex
    ].hysteresis = 0.1;
    this.resetVisualization();
  }

  startKissTestFSM() {
    this.disableUserMappings();
    this.currentTest = 'kiss';
    this.currentParameters = this.currentParametersDefault();
    this.resolution = this.results.kiss.resolution;
    this.mappings.settings.mappings[this.wizardTempMappingIndex].movement = {
      name: 'kiss',
      function: 'findMouthPuck',
      source: MovementSource.face,
    };
    this.mappings.settings.mappings[
      this.wizardTempMappingIndex
    ].detectionAction = { name: 'calibration', function: 'actionCalibration' };
    this.mappings.settings.mappings[
      this.wizardTempMappingIndex
    ].hysteresis = 0.1;
    this.resetVisualization();
  }

  startEyeGazeHorizontalTestFSM() {
    this.disableUserMappings();
    this.currentTest = 'eyeGazeHorizontal';
    this.currentParameters = this.currentParametersDefault();
    this.resolution = this.results.eyeGazeHorizontal.resolution;
    this.mappings.settings.mappings[this.wizardTempMappingIndex].movement = {
      name: 'eyeGazeHorizontal',
      function: 'findGazeHorizontal',
      source: MovementSource.face,
    };
    this.mappings.settings.mappings[
      this.wizardTempMappingIndex
    ].detectionAction = { name: 'calibration', function: 'actionCalibration' };
    this.mappings.settings.mappings[
      this.wizardTempMappingIndex
    ].hysteresis = 0.05;
    this.resetVisualization();
  }

  startEyeGazeVerticalTestFSM() {
    this.disableUserMappings();
    this.currentTest = 'eyeGazeVertical';
    this.currentParameters = this.currentParametersDefault();
    this.resolution = this.results.eyeGazeVertical.resolution;
    this.mappings.settings.mappings[this.wizardTempMappingIndex].movement = {
      name: 'eyeGazeVertical',
      function: 'findGazeVertical',
      source: MovementSource.face,
    };
    this.mappings.settings.mappings[
      this.wizardTempMappingIndex
    ].detectionAction = { name: 'calibration', function: 'actionCalibration' };
    this.mappings.settings.mappings[
      this.wizardTempMappingIndex
    ].hysteresis = 0.05;
    this.resetVisualization();
  }

  startEyeGazeTestFSM() {
    this.disableUserMappings();
    this.currentTest = 'eyeGazeLeft';
    this.currentParameters = this.currentParametersDefault();
    this.resolution = this.results.eyeGazeLeft.resolution;
    this.mappings.settings.mappings[this.wizardTempMappingIndex].resolution = 2;
    this.mappings.settings.mappings[this.wizardTempMappingIndex].movement = {
      name: 'eyeGazeLeft',
      function: 'findGazeLeft',
      source: MovementSource.face,
    };
    this.mappings.settings.mappings[
      this.wizardTempMappingIndex
    ].detectionAction = {
      name: 'calibration',
      function: 'actionDiscreteWizardEvent',
    };
    //this.mappings.settings.mappings[this.wizardTempMappingIndex].hysteresis = 0.05;
    this.mappings.settings.mappings[
      this.wizardTempMappingIndex
    ].detectionThreshold = 0.6;
    this.mappings.settings.mappings[this.wizardTempMappingIndex].actionArg =
      'eyeGazeLeft';
    // this.mappings.settings.mappings[this.wizardTempMappingIndex]
    //   .actionSound = {name: 'Bip', function: this.mappings.soundTulum, filterClass: ActionFilterClass.sound};

    // Secondary mappings
    this.mappings.settings.mappings[
      this.secondaryWizardMappings[0]
    ].resolution = 2;
    this.mappings.settings.mappings[this.secondaryWizardMappings[0]].movement =
      {
        name: 'eyeGazeRight',
        function: 'findGazeRight',
        source: MovementSource.face,
      };
    this.mappings.settings.mappings[
      this.secondaryWizardMappings[0]
    ].detectionAction = {
      name: 'calibration',
      function: 'actionDiscreteWizardEvent',
    };
    //this.mappings.settings.mappings[this.secondaryWizardMappings[0]].hysteresis = 0.05;
    this.mappings.settings.mappings[
      this.secondaryWizardMappings[0]
    ].detectionThreshold = 0.6;
    this.mappings.settings.mappings[this.secondaryWizardMappings[0]].actionArg =
      'eyeGazeRight';

    this.mappings.settings.mappings[
      this.secondaryWizardMappings[1]
    ].resolution = 2;
    this.mappings.settings.mappings[this.secondaryWizardMappings[1]].movement =
      {
        name: 'eyeGazeUp',
        function: 'findGazeUp',
        source: MovementSource.face,
      };
    this.mappings.settings.mappings[
      this.secondaryWizardMappings[1]
    ].detectionAction = {
      name: 'calibration',
      function: 'actionDiscreteWizardEvent',
    };
    ///this.mappings.settings.mappings[this.secondaryWizardMappings[1]].hysteresis = 0.05;
    this.mappings.settings.mappings[
      this.secondaryWizardMappings[1]
    ].detectionThreshold = 0.3;
    this.mappings.settings.mappings[this.secondaryWizardMappings[1]].actionArg =
      'eyeGazeUp';

    // Head movements for enforcing head direction;
    this.mappings.settings.mappings[
      this.secondaryWizardMappings[2]
    ].resolution = 2;
    this.mappings.settings.mappings[this.secondaryWizardMappings[2]].movement =
      {
        name: 'headPointingAway',
        function: 'findHeadPointingAway',
        source: MovementSource.face,
      };
    this.mappings.settings.mappings[
      this.secondaryWizardMappings[2]
    ].detectionAction = {
      name: 'calibration',
      function: 'actionDiscreteWizardEvent',
    };
    this.mappings.settings.mappings[
      this.secondaryWizardMappings[2]
    ].detectionThreshold = 0.25;
    this.mappings.settings.mappings[this.secondaryWizardMappings[2]].actionArg =
      'headPointingAway';

    this.resetVisualization();

    // this.mappings.settings.mappings[this.secondaryWizardMappings[3]].movement =
    //   {name: 'headPitch', function: this.mappings.findPitch, source: MovementSource.face};
    // this.mappings.settings.mappings[this.secondaryWizardMappings[3]]
    //   .action = {name: 'calibration', function: 'actionCalibration'};
  }

  startEyeBlinkTestFSM() {
    this.disableUserMappings();
    this.currentTest = 'leftRightBlink';
    this.results.leftRightBlink.fsmState = 'start';
    this.resolution = this.results.leftRightBlink.resolution;
    this.mappings.settings.mappings[this.wizardTempMappingIndex].movement = {
      name: 'leftRightBlink',
      function: 'findLeftAndRightEyeBlink',
      source: MovementSource.face,
    };
    this.mappings.settings.mappings[
      this.wizardTempMappingIndex
    ].detectionAction = { name: 'calibration', function: 'actionCalibration' };
    this.mappings.settings.mappings[
      this.wizardTempMappingIndex
    ].hysteresis = 0.05;
    this.mappings.settings.mappings[
      this.wizardTempMappingIndex
    ].detectionThreshold = 0.3;
    this.mappings.settings.mappings[this.wizardTempMappingIndex].actionSound = {
      name: 'Bip',
      function: 'soundTulum',
      filterClass: ActionFilterClass.sound,
    };
    this.currentParameters = this.currentParametersDefault();
    this.resetVisualization();

    // Secondary mappings
    this.mappings.settings.mappings[this.secondaryWizardMappings[0]].movement =
      {
        name: 'leftRightBlink',
        function: 'findLeftAndRightEyeBlink',
        source: MovementSource.face,
      };
    this.mappings.settings.mappings[
      this.secondaryWizardMappings[0]
    ].detectionAction = {
      name: 'calibration',
      function: 'actionDiscreteWizardEvent',
    };
    //this.mappings.settings.mappings[this.secondaryWizardMappings[0]].hysteresis = 0.05;
    this.mappings.settings.mappings[
      this.secondaryWizardMappings[0]
    ].detectionThreshold = 0.4;
    this.mappings.settings.mappings[this.secondaryWizardMappings[0]].actionArg =
      'leftRightBlink';

    this.mappings.settings.mappings[this.secondaryWizardMappings[1]].movement =
      {
        name: 'leftBlink',
        function: 'findLeftOnlyEyeBlink',
        source: MovementSource.face,
      };
    this.mappings.settings.mappings[
      this.secondaryWizardMappings[1]
    ].detectionAction = {
      name: 'calibration',
      function: 'actionDiscreteWizardEvent',
    };
    ///this.mappings.settings.mappings[this.secondaryWizardMappings[1]].hysteresis = 0.05;
    this.mappings.settings.mappings[
      this.secondaryWizardMappings[1]
    ].detectionThreshold = 0.3;
    this.mappings.settings.mappings[this.secondaryWizardMappings[1]].actionArg =
      'leftBlink';

    this.mappings.settings.mappings[this.secondaryWizardMappings[2]].movement =
      {
        name: 'rightBlink',
        function: 'findRightOnlyEyeBlink',
        source: MovementSource.face,
      };
    this.mappings.settings.mappings[
      this.secondaryWizardMappings[2]
    ].detectionAction = {
      name: 'calibration',
      function: 'actionDiscreteWizardEvent',
    };
    //this.mappings.settings.mappings[this.secondaryWizardMappings[2]].hysteresis = 0.00;
    this.mappings.settings.mappings[
      this.secondaryWizardMappings[2]
    ].detectionThreshold = 0.3;
    this.mappings.settings.mappings[this.secondaryWizardMappings[2]].actionArg =
      'rightBlink';
  }

  // FSMs
   headRotationTestFsm() {
    // Skip if not head rotation
    if (['headRoll', 'headPitch', 'headYaw'].indexOf(this.currentTest) < 0) {
      return;
    }
    // Se o fsmState não estiver definido ou inválido a FSM não faz nada
    switch (this.currentParameters.fsmState) {
      case 'start':
        this.currentParameters.fsmState = 'commandCenter';
        this.results[this.currentTest].max = 1;
        this.results[this.currentTest].min = 0;
        this.sampleArray = [];
        this.timestamp1 = Date.now();
        break;
         case  'commandCenter':
        // Centralize sua cabeça e permaneça parado
        this.commandText = this.headCommands.center1[this.currentTest];
        this.timestamp1 = undefined;
        this.tipImagePath = this.headImages.center1[this.currentTest];
        this.updateVideoElement();
        // Inicia timer da próxima etapa só quando termina de falar
        this.voice.speakSystem(this.commandText).then(() => {
          this.timestamp1 = Date.now();
        });
        this.currentParameters.fsmState = 'commandCenterWait';
        break;
      case 'commandCenterWait':
        if (this.timestamp1 && Date.now() - this.timestamp1 > 1500) {
          this.sampleArray = [];
          this.currentParameters.fsmState = 'captureCenter';
          this.capturing = true;
        }
        break;
      case 'captureCenter':
        // salva amostras por dois segundos
        this.sampleArray.push(this.output);
        if (this.sampleArray.length >= 30) {
          this.currentParameters.fsmState = 'evaluateCenter';
          this.voice.speakSystem('pronto');
          this.capturing = false;
        }
        break;
      case 'evaluateCenter':
        // Salva média no center
        this.currentParameters.center =
        this.sampleArray.reduce((a, b) => a + b, 0) / this.sampleArray.length;
        console.log(this.currentParameters.center, this.sampleArray);

        // Penalty if center is too offset
        if (Math.abs(this.currentParameters.center - 0.5) > 0.1) {
          this.currentParameters.score *= 0.9;
        } else if (Math.abs(this.currentParameters.center - 0.5) > 0.2) {
          this.currentParameters.score *= 0.8;
        }

        // Vire sua cabeça o máximo para a direita
        this.currentParameters.fsmState = 'commandMax';
        break;
      case 'commandMax':
        // Detecta início do movimento
        this.commandText = this.headCommands.max[this.currentTest];
        this.timestamp1 = undefined;
        this.tipImagePath = this.headImages.max[this.currentTest]; // DANDO ERRO AQ
        this.updateVideoElement();
        this.voice.speakSystem(this.commandText).then(() => {
          this.timestamp1 = Date.now();
        });
        this.currentParameters.fsmState = 'commandMaxWait';
        break;
      case 'commandMaxWait':
        // Detecta início do movimento
        if (
          this.timestamp1 &&
          (this.output > this.currentParameters.center * 1.2 ||
            Date.now() - this.timestamp1 > 2000)
        ) {
          this.sampleArray = [];
          this.currentParameters.fsmState = 'captureMax';
          this.capturing = true;
        }
        break;
      case 'captureMax':
        // salva amostras por dois segundos
        this.sampleArray.push(this.output);
        if (this.sampleArray.length >= 30) {
          this.voice.speakSystem('pronto');
          this.capturing = false;
          this.currentParameters.fsmState = 'evaluateMax';
        }
        break;
      case 'evaluateMax':
        // extrai 3 maiores amostras e salva média no max
        this.currentParameters.max = Math.max.apply(null, this.sampleArray);
        console.log(this.currentParameters.max, this.sampleArray);
        this.currentParameters.fsmState = 'commandCenter2';
        break;
      case 'commandCenter2':
        // Centralize sua cabeça e permaneça parado
        this.commandText = this.headCommands.center1[this.currentTest];
        this.timestamp1 = undefined;
        this.tipImagePath = this.headImages.center1[this.currentTest];
        this.updateVideoElement();
        this.target = this.currentParameters.center;
        this.voice.speakSystem(this.commandText).then(() => {
          this.timestamp1 = Date.now();
        });
        this.currentParameters.fsmState = 'commandCenter2Wait';
        break;
      case 'commandCenter2Time':
        // Medição de tempo de resposta
        if (Math.abs(this.output - this.target) < 0.5 / this.resolution) {
          this.currentParameters.responseTime = Date.now() - this.timestamp1;
          this.timestamp1 = Date.now();
          this.currentParameters.fsmState = 'commandCenter2Wait';
        }
        // Timeout de 6s - desiste
        else if (Date.now() - this.timestamp1 > 5000) {
          this.currentParameters.precision = 0.1;
          console.log('precision 30 timeout', this.currentParameters.precision);
          this.currentParameters.fsmState = 'commandMin';
        }
        break;
      case 'commandCenter2Wait':
        if (this.timestamp1 && Date.now() - this.timestamp1 > 3000) {
          this.sampleArray = [];
          this.target = undefined;
          this.currentParameters.fsmState = 'commandMin';
        }
        break;
      case 'commandMin':
        this.commandText = this.headCommands.min[this.currentTest];
        this.timestamp1 = undefined;
        this.tipImagePath = this.headImages.min[this.currentTest];
        this.updateVideoElement();
        this.voice.speakSystem('agora ' + this.commandText).then(() => {
          this.timestamp1 = Date.now();
        });
        this.currentParameters.fsmState = 'commandMinWait';
        break;
      case 'commandMinWait':
        // Detecta início do movimento
        if (
          this.timestamp1 &&
          (this.output < this.currentParameters.center * 0.8 ||
            Date.now() - this.timestamp1 > 2000)
        ) {
          this.sampleArray = [];
          this.currentParameters.fsmState = 'captureMin';
          this.capturing = true;
        }
        break;
      case 'captureMin':
        // salva amostras por 3 segundos
        this.sampleArray.push(this.output);
        if (this.sampleArray.length >= 30) {
          this.voice.speakSystem('perfeito.');
          this.capturing = false;
          this.currentParameters.fsmState = 'evaluateMin';
        }
        break;
      case 'evaluateMin':
        // extrai 3 maiores amostras e salva média no max
        this.currentParameters.min = Math.min.apply(null, this.sampleArray);
        console.log(
          this.currentParameters.min,
          this.currentParameters.center,
          this.currentParameters.max
        );

        // Avalia com base em max e min se vale a pena tratar como contínuio.
        if (this.currentParameters.max - this.currentParameters.min > 0.3) {
          this.currentParameters.fsmState = 'target1';
        } else if (
          this.currentParameters.max - this.currentParameters.min <
          0.1
        ) {
          this.currentParameters.score *= 0.5;

          this.currentParameters.tested = 'fail';
          this.currentParameters.movement = this.currentParameters.movement;
          this.currentParameters = this.currentParameters;

          this.endCurrentTest(true);
        } else {
          // 0.1 < range < 0.3
          this.currentParameters.score *= 0.8;
          this.currentParameters.precision = 2;

          this.currentParameters.tested = 'binary';
          this.currentParameters.movement = this.currentParameters.movement;
          this.currentParameters = this.currentParameters;

          this.endCurrentTest(true);
        }

        this.results[this.currentTest].min = this.currentParameters.min;
        this.results[this.currentTest].center = this.currentParameters.center;
        this.results[this.currentTest].max = this.currentParameters.max;
        break;
      case 'target1':
        this.commandText = 'Pare dentro do alvo';
        // TODO: Colocar uma seta bem chamativa indicando 30%
        this.sampleArray = [];
        this.timestamp1 = undefined;
        this.voice.speakSystem('agora ' + this.commandText).then(() => {
          this.timestamp1 = Date.now();
          this.target = 0.3;
        });
        this.currentParameters.fsmState = 'target1ResponseTime'; // Encerra execução
        break;
      case 'target1ResponseTime':
        // Medição de tempo de resposta
        if (Math.abs(this.output - this.target) < 0.5 / this.resolution) {
          this.currentParameters.responseTime += Date.now() - this.timestamp1;
          this.timestamp1 = Date.now();
          this.currentParameters.fsmState = 'target1Wait';
        }
        // Timeout de 5s - desiste
        else if (Date.now() - this.timestamp1 > 5000) {
          this.currentParameters.precision = 0.1;
          this.currentParameters.score *= 0.9;
          console.log('precision 30 timeout', this.currentParameters.precision);
          this.currentParameters.fsmState = 'target2';
        }
        break;
      case 'target1Wait':
        // Medição de tempo de resposta
        if (Math.abs(this.output - this.target) < 0.5 / this.resolution) {
          this.currentParameters.responseTime = Date.now() - this.timestamp1;
        }
        if (this.timestamp1 && Date.now() - this.timestamp1 > 1000) {
          // Se estiver dentro do range soma
          if (Math.abs(this.output - this.target) < 0.5 / this.resolution) {
            this.sampleArray.push(this.output);
          }

          // Se estiver muito fora zera
          else if (Math.abs(this.output - this.target) > 1 / this.resolution) {
            this.sampleArray = [];
          }

          if (this.sampleArray.length > 10) {
            this.sampleArray = [];
            this.currentParameters.fsmState = 'captureTarget1';
          }

          // Timeout de 6s - desiste
          if (Date.now() - this.timestamp1 > 5000) {
            this.currentParameters.precision = 0.1;
            this.currentParameters.score *= 0.9;
            console.log(
              'precision 30 timeout',
              this.currentParameters.precision
            );
            this.currentParameters.fsmState = 'target2';
          }
        }
        break;
      case 'captureTarget1':
        // salva amostras por 3 segundos
        this.sampleArray.push(this.output);
        if (this.sampleArray.length >= 30) {
          this.target = undefined;
          this.voice.speakSystem('pronto');
          this.currentParameters.fsmState = 'evaluateTarget1';
        }
        break;
      case 'evaluateTarget1':
        // calcula desvio padrão
        this.currentParameters.precision = this.standardDeviation(
          this.sampleArray
        );
        if (this.currentParameters.precision > 0.05) {
          this.currentParameters.score *= 0.9;
        } else if (this.currentParameters.precision > 0.1) {
          this.currentParameters.score *= 0.8;
        }
        if (this.currentParameters.responseTime > 800) {
          this.currentParameters.score *= 0.9;
        } else if (this.currentParameters.responseTime > 1600) {
          this.currentParameters.score *= 0.8;
        }
        console.log('precision', this.currentParameters);
        this.currentParameters.fsmState = 'target2';
        break;
      case 'target2':
        this.commandText = 'Entre no alvo novamente';
        // TODO: Colocar uma seta bem chamativa indicando 30%
        this.sampleArray = [];
        this.timestamp1 = undefined;
        this.voice.speakSystem(this.commandText).then(() => {
          this.timestamp1 = Date.now();
          this.target = 0.6;
        });
        this.currentParameters.fsmState = 'target2ResponseTime';
        break;
      case 'target2ResponseTime':
        // Medição de tempo de resposta
        if (Math.abs(this.output - this.target) < 0.5 / this.resolution) {
          this.currentParameters.responseTime =
            (this.currentParameters.responseTime +
              (Date.now() - this.timestamp1)) /
            2;
          this.timestamp1 = Date.now();
          this.currentParameters.fsmState = 'target2Wait';
        }
        // Timeout de 5s - desiste
        else if (Date.now() - this.timestamp1 > 5000) {
          this.currentParameters.precision += 0.1;
          this.currentParameters.score *= 0.9;
          console.log('precision 60 timeout', this.currentParameters.precision);

          this.currentParameters.tested = 'binary';
          this.results[this.currentTest] = this.currentParameters;

          this.endCurrentTest(true);
        }
        break;
      case 'target2Wait':
        if (this.timestamp1 && Date.now() - this.timestamp1 > 2000) {
          // Se estiver dentro do range soma
          if (Math.abs(this.output - this.target) < 0.5 / this.resolution) {
            this.sampleArray.push(this.output);
          }
          // Se estiver muito fora zera
          else if (Math.abs(this.output - this.target) > 1 / this.resolution) {
            this.sampleArray = [];
          }

          if (this.sampleArray.length > 10) {
            this.sampleArray = [];
            this.currentParameters.fsmState = 'captureTarget2';
          }

          // Timeout de 6s - desiste
          if (Date.now() - this.timestamp1 > 6000) {
            this.currentParameters.precision += 0.1;
            this.currentParameters.score *= 0.9;
            console.log(
              'precision 60 timeout',
              this.currentParameters.precision
            );

            this.currentParameters.tested = 'binary';
            this.results[this.currentTest] = this.currentParameters;

            this.endCurrentTest(true);
          }
        }
        break;
      case 'captureTarget2':
        // salva amostras por 3 segundos
        this.sampleArray.push(this.output);
        if (this.sampleArray.length >= 30) {
          this.voice.speakSystem('pronto');
          this.target = undefined;
          this.currentParameters.fsmState = 'evaluateTarget2';
        }
        break;
      case 'evaluateTarget2':
        // calcula desvio padrão
        this.currentParameters.precision =
          (this.currentParameters.precision +
            this.standardDeviation(this.sampleArray)) /
          2;
        if (this.currentParameters.precision > 0.05) {
          this.currentParameters.score *= 0.9;
        } else if (this.currentParameters.precision > 0.1) {
          this.currentParameters.score *= 0.8;
        }
        if (this.currentParameters.responseTime > 800) {
          this.currentParameters.score *= 0.9;
        } else if (this.currentParameters.responseTime > 1600) {
          this.currentParameters.score *= 0.8;
        }
        this.currentParameters.tested = 'digital';
        this.results[this.currentTest] = this.currentParameters;

        this.endCurrentTest(true);
        break;
      default:
        break;
    }
  }

  faceMouthTestFsm() {
    // Skip if not mouth
    if (['mouthOpen', 'smile', 'kiss'].indexOf(this.currentTest) < 0) {
      return;
    }
    console.log('fsm faceMouthTestFsm', this.currentTest, this.currentParameters.fsmState);
    // Se o fsmState não estiver definido ou inválido a FSM não faz nada
    switch (this.currentParameters.fsmState) {
      case 'start':
        this.currentParameters.fsmState = 'commandMax';
        this.results[this.currentTest].max = 1;
        this.results[this.currentTest].min = 0;
        this.sampleArray = [];
        this.timestamp1 = Date.now();
        break;
      case 'commandMax':
        // Detecta início do movimento
        this.commandText = this.mouthCommands.max[this.currentTest];
        this.timestamp1 = undefined;
        this.tipImagePath = this.mouthImages.max[this.currentTest];
        this.updateVideoElement();
        this.voice.speakSystem(this.commandText).then(() => {
          this.timestamp1 = Date.now();
        });
        this.currentParameters.fsmState = 'commandMaxWait';
        break;
      case 'commandMaxWait':
        // Detecta início do movimento
        if (
          this.timestamp1 &&
          (this.output > 0.5 || Date.now() - this.timestamp1 > 2000)
        ) {
          this.sampleArray = [];
          this.capturing = true;
          this.currentParameters.fsmState = 'captureMax';
        }
        break;
      case 'captureMax':
        // salva amostras por dois segundos
        this.sampleArray.push(this.output);
        if (this.sampleArray.length >= 30) {
          this.voice.speakSystem('pronto');
          this.capturing = false;
          this.currentParameters.fsmState = 'evaluateMax';
        }
        break;
      case 'evaluateMax':
        // extrai 3 maiores amostras e salva média no max
        this.currentParameters.max = Math.max.apply(null, this.sampleArray);
        this.results[this.currentTest].max = this.currentParameters.max; // Reajusta a escala imediatamente
        console.log(this.currentParameters.max, this.sampleArray);
        this.currentParameters.fsmState = 'commandCenter2';
        break;
      case 'commandCenter2':
        // Centralize sua cabeça e permaneça parado
        this.commandText = this.mouthCommands.center[this.currentTest];
        this.timestamp1 = undefined;
        this.tipImagePath = this.mouthImages.center[this.currentTest];
        this.updateVideoElement();
        this.voice.speakSystem('agora ' + this.commandText).then(() => {
          this.timestamp1 = Date.now();
          this.target = 0.5;
        });
        this.currentParameters.fsmState = 'commandCenter2Time';
        break;
      case 'commandCenter2Time':
        // Medição de tempo de resposta
        if (Math.abs(this.output - this.target) < 0.5 / this.resolution) {
          this.sampleArray = [];
          this.currentParameters.responseTime = Date.now() - this.timestamp1;
          this.timestamp1 = Date.now();
          this.capturing = true;
          this.currentParameters.fsmState = 'captureCenter2';
        }
        // Timeout de 6s - desiste
        else if (Date.now() - this.timestamp1 > 2000) {
          this.currentParameters.precision = 0.1;
          console.log('precision 30 timeout', this.currentParameters.precision);
          this.sampleArray = [];
          this.capturing = true;
          this.currentParameters.fsmState = 'captureCenter2';
        }
        break;
      case 'captureCenter2':
        // salva amostras por dois segundos
        this.sampleArray.push(this.output);
        if (this.sampleArray.length >= 30) {
          this.voice.speakSystem('pronto');
          this.target = undefined;
          this.capturing = false;
          this.currentParameters.fsmState = 'evaluateCenter2';
        }
        break;
      case 'evaluateCenter2':
        // Salva média no center
        this.currentParameters.center =
          this.sampleArray.reduce((a, b) => a + b, 0) / this.sampleArray.length;
        console.log(this.currentParameters.center, this.sampleArray);
        // Vire sua cabeça o máximo para a direita
        this.currentParameters.fsmState = 'commandMin';
        break;
      case 'commandMin':
        this.commandText = this.mouthCommands.min[this.currentTest];
        this.timestamp1 = undefined;
        this.tipImagePath = this.mouthImages.min[this.currentTest];
        this.updateVideoElement();
        this.voice.speakSystem(this.commandText).then(() => {
          this.timestamp1 = Date.now();
        });
        this.currentParameters.fsmState = 'commandMinWait';
        break;
      case 'commandMinWait':
        // Detecta início do movimento
        if (
          this.timestamp1 &&
          (this.output < 0.1 || Date.now() - this.timestamp1 > 2000)
        ) {
          this.currentParameters.responseTime = Date.now() - this.timestamp1;
          this.sampleArray = [];
          this.capturing = true;
          this.currentParameters.fsmState = 'captureMin';
        }
        break;
      case 'captureMin':
        // salva amostras por 3 segundos
        this.sampleArray.push(this.output);
        if (this.sampleArray.length >= 30) {
          this.voice.speakSystem('perfeito.');
          this.capturing = false;
          this.currentParameters.fsmState = 'evaluateMin';
        }
        break;
      case 'evaluateMin':
        // extrai 3 maiores amostras e salva média no max
        this.currentParameters.min = Math.min.apply(null, this.sampleArray);
        console.log(
          this.currentParameters.min,
          this.currentParameters.center,
          this.currentParameters.max
        );

        // Avalia com base em max e min se vale a pena tratar como contínuio.
        if (this.currentParameters.max - this.currentParameters.min > 0.3) {
          if (this.currentTest === 'mouthOpen') { // Try digital only for mouth open
            this.currentParameters.fsmState = 'target1';
          } else { // End otherwise
            this.currentParameters.tested = 'binary';
            this.results[this.currentTest] = this.currentParameters;
            this.endCurrentTest(true);
          }

        } else if (
          this.currentParameters.max - this.currentParameters.min <
          0.1
        ) {
          this.currentParameters.score *= 0.5;

          this.currentParameters.tested = 'fail';
          this.results[this.currentTest] = this.currentParameters;

          this.endCurrentTest(true);
        } else {
          // 0.1 < range < 0.3
          this.currentParameters.score *= 0.8;
          this.currentParameters.precision = 2;

          this.currentParameters.tested = 'binary';
          this.results[this.currentTest] = this.currentParameters;

          this.endCurrentTest(true);
        }

        this.results[this.currentTest].min = this.currentParameters.min;
        this.results[this.currentTest].center = this.currentParameters.center;
        this.results[this.currentTest].max = this.currentParameters.max;
        break;
      case 'target1':
        this.commandText = 'Pare dentro do alvo';
        // TODO: Colocar uma seta bem chamativa indicando 30%
        this.sampleArray = [];
        this.timestamp1 = undefined;
        this.voice.speakSystem('agora ' + this.commandText).then(() => {
          this.timestamp1 = Date.now();
          this.target = 0.8;
        });
        this.currentParameters.fsmState = 'target1ResponseTime'; // Encerra execução
        break;
      case 'target1ResponseTime':
        // Medição de tempo de resposta
        if (Math.abs(this.output - this.target) < 0.5 / this.resolution) {
          this.currentParameters.responseTime += Date.now() - this.timestamp1;
          this.timestamp1 = Date.now();
          this.currentParameters.fsmState = 'target1Wait';
        }
        // Timeout de 5s - desiste
        else if (Date.now() - this.timestamp1 > 5000) {
          this.currentParameters.precision = 0.1;
          this.currentParameters.score *= 0.9;
          console.log('precision 30 timeout', this.currentParameters.precision);
          this.currentParameters.fsmState = 'target2';
        }
        break;
      case 'target1Wait':
        // Medição de tempo de resposta
        if (Math.abs(this.output - this.target) < 0.5 / this.resolution) {
          this.currentParameters.responseTime = Date.now() - this.timestamp1;
        }
        if (this.timestamp1 && Date.now() - this.timestamp1 > 1000) {
          // Se estiver dentro do range soma
          if (Math.abs(this.output - this.target) < 0.5 / this.resolution) {
            this.sampleArray.push(this.output);
          }

          // Se estiver muito fora zera
          else if (Math.abs(this.output - this.target) > 1 / this.resolution) {
            this.sampleArray = [];
          }

          if (this.sampleArray.length > 10) {
            this.sampleArray = [];
            this.currentParameters.fsmState = 'captureTarget1';
          }

          // Timeout de 6s - desiste
          if (Date.now() - this.timestamp1 > 6000) {
            this.currentParameters.precision = 0.1;
            this.currentParameters.score *= 0.9;
            console.log(
              'precision 30 timeout',
              this.currentParameters.precision
            );
            this.currentParameters.fsmState = 'target2';
          }
        }
        break;
      case 'captureTarget1':
        // salva amostras por 3 segundos
        this.sampleArray.push(this.output);
        if (this.sampleArray.length >= 30) {
          this.target = undefined;
          this.voice.speakSystem('pronto');
          this.currentParameters.fsmState = 'evaluateTarget1';
        }
        break;
      case 'evaluateTarget1':
        // calcula desvio padrão
        this.currentParameters.precision = this.standardDeviation(
          this.sampleArray
        );
        if (this.currentParameters.precision > 0.05) {
          this.currentParameters.score *= 0.9;
        } else if (this.currentParameters.precision > 0.1) {
          this.currentParameters.score *= 0.8;
        }
        if (this.currentParameters.responseTime > 800) {
          this.currentParameters.score *= 0.9;
        } else if (this.currentParameters.responseTime > 1600) {
          this.currentParameters.score *= 0.8;
        }
        console.log('precision', this.currentParameters);
        console.log('precision', this.currentParameters.precision);
        this.currentParameters.fsmState = 'target2';
        break;
      case 'target2':
        this.commandText = 'Entre no alvo novamente';
        // TODO: Colocar uma seta bem chamativa indicando 30%
        this.sampleArray = [];
        this.timestamp1 = undefined;
        this.voice.speakSystem(this.commandText).then(() => {
          this.timestamp1 = Date.now();
          this.target = 0.2;
        });
        this.currentParameters.fsmState = 'target2ResponseTime';
        break;
      case 'target2ResponseTime':
        // Medição de tempo de resposta
        if (Math.abs(this.output - this.target) < 0.5 / this.resolution) {
          this.currentParameters.responseTime =
            (this.currentParameters.responseTime +
              (Date.now() - this.timestamp1)) /
            2;
          this.timestamp1 = Date.now();
          this.currentParameters.fsmState = 'target2Wait';
        }
        // Timeout de 5s - desiste
        else if (Date.now() - this.timestamp1 > 5000) {
          this.currentParameters.precision += 0.1;
          this.currentParameters.score *= 0.9;
          console.log('precision 60 timeout', this.currentParameters.precision);

          this.currentParameters.tested = 'binary';
          this.results[this.currentTest] = this.currentParameters;

          this.endCurrentTest(true);
        }
        break;
      case 'target2Wait':
        if (this.timestamp1 && Date.now() - this.timestamp1 > 2000) {
          // Se estiver dentro do range soma
          if (Math.abs(this.output - this.target) < 0.5 / this.resolution) {
            this.sampleArray.push(this.output);
          }

          // Se estiver muito fora zera
          else if (Math.abs(this.output - this.target) > 1 / this.resolution) {
            this.sampleArray = [];
          }

          if (this.sampleArray.length > 10) {
            this.sampleArray = [];
            this.currentParameters.fsmState = 'captureTarget2';
          }

          // Timeout de 6s - desiste
          if (Date.now() - this.timestamp1 > 6000) {
            this.currentParameters.precision += 0.1;
            this.currentParameters.score *= 0.9;
            console.log(
              'precision 60 timeout',
              this.currentParameters.precision
            );

            this.currentParameters.tested = 'binary';
            this.results[this.currentTest] = this.currentParameters;

            this.endCurrentTest(true);
          }
        }
        break;
      case 'captureTarget2':
        // salva amostras por 3 segundos
        this.sampleArray.push(this.output);
        if (this.sampleArray.length >= 30) {
          this.voice.speakSystem('pronto');
          this.target = undefined;
          this.currentParameters.fsmState = 'evaluateTarget2';
        }
        break;
      case 'evaluateTarget2':
        // calcula desvio padrão
        this.currentParameters.precision =
          (this.currentParameters.precision +
            this.standardDeviation(this.sampleArray)) /
          2;
        if (this.currentParameters.precision > 0.05) {
          this.currentParameters.score *= 0.9;
        } else if (this.currentParameters.precision > 0.1) {
          this.currentParameters.score *= 0.8;
        }
        if (this.currentParameters.responseTime > 800) {
          this.currentParameters.score *= 0.9;
        } else if (this.currentParameters.responseTime > 1600) {
          this.currentParameters.score *= 0.8;
        }

        if (this.currentTest === 'mouthOpen') {
          this.currentParameters.tested = 'digital';
        } else {
          this.currentParameters.tested = 'binary';
        }

        this.results[this.currentTest] = this.currentParameters;

        this.endCurrentTest(true);
        break;
      default:
        console.log('fsm default', this.currentTest);
        break;
    }
  }

  faceEyeBlinkTestFsm() { // piscada aquii
    // Skip if not head rotation
    if (
      ['leftRightBlink', 'leftBlink', 'rightBlink'].indexOf(this.currentTest) <
      0
    ) {
      return;
    }
    // Se o fsmState não estiver definido ou inválido a FSM não faz nada
    switch (this.currentParameters.fsmState) {
      case 'start':
        // this.results.leftRightBlink.tested = 'fail';
        // this.results.leftBlink.tested = 'fail';
        // this.results.rightBlink.tested = 'fail';
        this.results[this.currentTest].max = 1;
        this.results[this.currentTest].min = 0;
        this.currentParameters.fsmState = 'commandBoth';
        break;
      case 'commandBoth':
        // Detecta início do movimento
        this.commandText = 'Feche ambos os olhos por um segundo';
        this.timestamp1 = undefined;
        this.tipImagePath = '/assets/images/MP4/piscar25Ambos.mp4';
        this.updateVideoElement();
        this.voice.speakSystem(this.commandText).then(() => {
          this.timestamp1 = Date.now();
        });
        this.currentParameters.fsmState = 'commandBothWait';
        break;
      case 'commandBothWait':
        // Detecta início do movimento
        if (
          this.timestamp1 &&
          Date.now() - this.lastEvents.leftRightBlink.timestamp < 4000 &&
          Date.now() - this.lastEvents.leftBlink.timestamp > 4000 &&
          Date.now() - this.lastEvents.rightBlink.timestamp > 4000
        ) {
          this.voice.speakSystem('perfeito. Abra os olhos.').then(() => {
            this.results.leftRightBlink.tested = 'digital';
            this.results.leftRightBlink.score = 1;
            this.timestamp1 = Date.now();
          });
          this.currentParameters.fsmState = 'commandOpenWait';
        }
        if (this.timestamp1 && Date.now() - this.timestamp1 > 6000) {
          // timeout
          this.commandText = 'Abra os olhos';
          this.timestamp1 = undefined;
          this.results.leftRightBlink.score = 0.6;
          this.voice.speakSystem(this.commandText).then(() => {
            this.timestamp1 = Date.now();
          });
          this.currentParameters.fsmState = 'commandOpenToRetryWait';
        }
        break;
      case 'commandOpenToRetryWait':
        // Detecta início do movimento
        if (
          this.timestamp1 &&
          Date.now() - this.lastEvents.leftRightBlink.timestamp > 4000 &&
          Date.now() - this.lastEvents.leftBlink.timestamp > 4000 &&
          Date.now() - this.lastEvents.rightBlink.timestamp > 4000
        ) {
          // this.ttsService.speakSystem('OK').then(()=>{
          //   this.timestamp1 = Date.now();
          // });
          this.currentParameters.fsmState = 'commandBoth2';
        }
        if (this.timestamp1 && Date.now() - this.timestamp1 > 6000) {
          // timeout
          // this.commandText = 'OK';
          // this.timestamp1 = undefined;
          // this.ttsService.speakSystem(this.commandText).then(()=>{
          //   this.timestamp1 = Date.now();
          // });
          this.currentParameters.fsmState = 'commandBoth2';
        }
        break;
      case 'commandBoth2':
        // Detecta início do movimento
        this.commandText = 'Feche ambos os olhos por um segundo';
        this.timestamp1 = undefined;
        this.tipImagePath = '/assets/images/MP4/piscar25Ambos.mp4';
        this.updateVideoElement();
        this.voice.speakSystem(this.commandText).then(() => {
          this.timestamp1 = Date.now();
        });
        this.currentParameters.fsmState = 'commandBothWait2';
        break;
      case 'commandBothWait2':
        // Detecta início do movimento
        if (
          this.timestamp1 &&
          Date.now() - this.lastEvents.leftRightBlink.timestamp < 4000 &&
          Date.now() - this.lastEvents.leftBlink.timestamp > 4000 &&
          Date.now() - this.lastEvents.rightBlink.timestamp > 4000
        ) {
          this.results.leftRightBlink.tested = 'binary';
          this.voice.speakSystem('perfeito. Abra os olhos').then(() => {
            this.timestamp1 = Date.now();
          });
          this.currentParameters.fsmState = 'commandOpenWait';
        }
        if (this.timestamp1 && Date.now() - this.timestamp1 > 6000) {
          // timeout
          this.commandText = 'Abra os olhos';
          this.timestamp1 = undefined;
          this.results.leftRightBlink.score *= 0.6;
          this.results.leftRightBlink.tested = 'fail';
          this.voice.speakSystem(this.commandText).then(() => {
            this.timestamp1 = Date.now();
          });
          this.currentParameters.fsmState = 'commandOpenWait';
        }
        break;
      case 'commandOpenWait':
        // Detecta início do movimento
        if (
          this.timestamp1 &&
          Date.now() - this.lastEvents.leftRightBlink.timestamp > 4000 &&
          Date.now() - this.lastEvents.leftBlink.timestamp > 4000 &&
          Date.now() - this.lastEvents.rightBlink.timestamp > 4000
        ) {
          // this.ttsService.speakSystem('OK').then(()=>{
          //   this.timestamp1 = Date.now();
          // });
          this.currentParameters.fsmState = 'commandRight';
        }
        if (this.timestamp1 && Date.now() - this.timestamp1 > 6000) {
          // timeout
          // this.commandText = 'OK';
          // this.timestamp1 = undefined;
          // this.ttsService.speakSystem(this.commandText).then(()=>{
          //   this.timestamp1 = Date.now();
          // });
          this.currentParameters.fsmState = 'commandRight';
        }
        break;

      case 'commandRight':
        // Detecta início do movimento
        this.commandText = 'Feche apenas seu olho direito';
        this.timestamp1 = undefined;
        this.tipImagePath = '/assets/images/MP4/piscar23Dir.mp4';
        this.updateVideoElement();
        this.voice.speakSystem(this.commandText).then(() => {
          this.timestamp1 = Date.now();
        });
        this.currentParameters.fsmState = 'commandRightWait';
        break;
      case 'commandRightWait':
        // Detecta início do movimento
        if (
          this.timestamp1 &&
          Date.now() - this.lastEvents.leftRightBlink.timestamp > 4000 &&
          Date.now() - this.lastEvents.leftBlink.timestamp > 4000 &&
          Date.now() - this.lastEvents.rightBlink.timestamp < 4000
        ) {
          this.results.rightBlink.tested = 'binary';
          this.results.rightBlink.score = 1;
          this.voice.speakSystem('perfeito. Abra os olhos.').then(() => {
            this.timestamp1 = Date.now();
          });
          this.currentParameters.fsmState = 'commandOpenWait3';
        }
        if (this.timestamp1 && Date.now() - this.timestamp1 > 3000) {
          // timeout
          this.commandText = 'Abra os olhos';
          this.results.rightBlink.score = 0.6;
          this.timestamp1 = undefined;
          this.voice.speakSystem(this.commandText).then(() => {
            this.timestamp1 = Date.now();
          });
          this.currentParameters.fsmState = 'commandOpenToRetryWait2';
        }
        break;
      case 'commandOpenToRetryWait2':
        // Detecta início do movimento
        if (
          this.timestamp1 &&
          Date.now() - this.lastEvents.leftRightBlink.timestamp > 4000 &&
          Date.now() - this.lastEvents.leftBlink.timestamp > 4000 &&
          Date.now() - this.lastEvents.rightBlink.timestamp > 4000
        ) {
          // this.ttsService.speakSystem('OK').then(()=>{
          //   this.timestamp1 = Date.now();
          // });
          this.currentParameters.fsmState = 'commandRight2';
        }
        if (this.timestamp1 && Date.now() - this.timestamp1 > 6000) {
          // timeout
          // this.commandText = 'OK';
          // this.timestamp1 = undefined;
          // this.ttsService.speakSystem(this.commandText).then(()=>{
          //   this.timestamp1 = Date.now();
          // });
          this.currentParameters.fsmState = 'commandRight2';
        }
        break;
      case 'commandRight2':
        // Detecta início do movimento
        this.commandText = 'Feche apenas seu olho direito';
        this.timestamp1 = undefined;
        this.tipImagePath = '/assets/images/MP4/piscar23Dir.mp4';
        this.updateVideoElement();
        this.voice.speakSystem(this.commandText).then(() => {
          this.timestamp1 = Date.now();
        });
        this.currentParameters.fsmState = 'commandRightWait2';
        break;
      case 'commandRightWait2':
        // Detecta início do movimento
        if (
          this.timestamp1 &&
          Date.now() - this.lastEvents.leftRightBlink.timestamp > 4000 &&
          Date.now() - this.lastEvents.leftBlink.timestamp > 4000 &&
          Date.now() - this.lastEvents.rightBlink.timestamp < 4000
        ) {
          this.results.rightBlink.tested = 'binary';
          this.voice.speakSystem('perfeito.').then(() => {
            this.timestamp1 = Date.now();
          });
          this.currentParameters.fsmState = 'commandOpenWait3';
        }
        if (this.timestamp1 && Date.now() - this.timestamp1 > 6000) {
          // timeout
          this.commandText = 'Abra os olhos';
          this.timestamp1 = undefined;
          this.results.rightBlink.tested = 'fail';
          this.results.rightBlink.score *= 0.6;
          this.voice.speakSystem(this.commandText).then(() => {
            this.timestamp1 = Date.now();
          });
          this.currentParameters.fsmState = 'commandOpenWait3';
        }
        break;
      case 'commandOpenWait3':
        // Detecta início do movimento
        if (
          this.timestamp1 &&
          Date.now() - this.lastEvents.leftRightBlink.timestamp > 4000 &&
          Date.now() - this.lastEvents.leftBlink.timestamp > 4000 &&
          Date.now() - this.lastEvents.rightBlink.timestamp > 4000
        ) {
          // this.ttsService.speakSystem('OK').then(()=>{
          //   this.timestamp1 = Date.now();
          // });
          this.currentParameters.fsmState = 'commandLeft';
        }
        if (this.timestamp1 && Date.now() - this.timestamp1 > 4000) {
          // timeout
          // this.commandText = 'OK';
          // this.timestamp1 = undefined;
          // this.ttsService.speakSystem(this.commandText).then(()=>{
          //   this.timestamp1 = Date.now();
          // });
          this.currentParameters.fsmState = 'commandLeft';
        }
        break;

      case 'commandLeft':
        // Detecta início do movimento
        this.commandText = 'Feche apenas seu olho esquerdo';
        this.timestamp1 = undefined;
        this.tipImagePath = '/assets/images/MP4/piscar24Esq.mp4';
        this.updateVideoElement();
        this.voice.speakSystem(this.commandText).then(() => {
          this.timestamp1 = Date.now();
        });
        this.currentParameters.fsmState = 'commandLeftWait';
        break;
      case 'commandLeftWait':
        // Detecta início do movimento
        if (
          this.timestamp1 &&
          Date.now() - this.lastEvents.leftRightBlink.timestamp > 4000 &&
          Date.now() - this.lastEvents.leftBlink.timestamp < 4000 &&
          Date.now() - this.lastEvents.rightBlink.timestamp > 4000
        ) {
          this.results.leftBlink.tested = 'binary';
          this.results.leftBlink.score = 1;
          this.voice.speakSystem('perfeito. Abra os olhos.').then(() => {
            this.timestamp1 = Date.now();
          });
          this.currentParameters.fsmState = 'commandOpenWait4';
        }
        if (this.timestamp1 && Date.now() - this.timestamp1 > 3000) {
          // timeout
          this.commandText = 'Abra os olhos';
          this.timestamp1 = undefined;
          this.results.leftBlink.score = 0.6;
          this.voice.speakSystem(this.commandText).then(() => {
            this.timestamp1 = Date.now();
          });
          this.currentParameters.fsmState = 'commandOpenToRetryWait3';
        }
        break;
      case 'commandOpenToRetryWait3':
        // Detecta início do movimento
        if (
          this.timestamp1 &&
          Date.now() - this.lastEvents.leftRightBlink.timestamp > 4000 &&
          Date.now() - this.lastEvents.leftBlink.timestamp > 4000 &&
          Date.now() - this.lastEvents.rightBlink.timestamp > 4000
        ) {
          // this.ttsService.speakSystem('OK').then(()=>{
          //   this.timestamp1 = Date.now();
          // });
          this.currentParameters.fsmState = 'commandLeft2';
        }
        if (this.timestamp1 && Date.now() - this.timestamp1 > 6000) {
          // timeout
          // this.commandText = 'OK';
          // this.timestamp1 = undefined;
          // this.ttsService.speakSystem(this.commandText).then(()=>{
          //   this.timestamp1 = Date.now();
          // });
          this.currentParameters.fsmState = 'commandLeft2';
        }
        break;
      case 'commandLeft2':
        // Detecta início do movimento
        this.commandText = 'Feche apenas seu olho esquerdo';
        this.timestamp1 = undefined;
        this.tipImagePath = '/assets/images/MP4/piscar24Esq.mp4';
        this.updateVideoElement();
        this.voice.speakSystem(this.commandText).then(() => {
          this.timestamp1 = Date.now();
        });
        this.currentParameters.fsmState = 'commandLeftWait2';
        break;
      case 'commandLeftWait2':
        // Detecta início do movimento
        if (
          this.timestamp1 &&
          Date.now() - this.lastEvents.leftRightBlink.timestamp > 4000 &&
          Date.now() - this.lastEvents.leftBlink.timestamp < 4000 &&
          Date.now() - this.lastEvents.rightBlink.timestamp > 4000
        ) {
          this.results.leftBlink.tested = 'binary';
          this.voice.speakSystem('perfeito. Abra os olhos').then(() => {
            this.timestamp1 = Date.now();
          });
          this.currentParameters.fsmState = 'commandOpenWait4';
        }
        if (this.timestamp1 && Date.now() - this.timestamp1 > 6000) {
          // timeout
          this.commandText = 'Abra os olhos';
          this.timestamp1 = undefined;
          this.results.leftBlink.tested = 'fail';
          this.results.leftBlink.score *= 0.6;
          this.voice.speakSystem(this.commandText).then(() => {
            this.timestamp1 = Date.now();
          });
          this.currentParameters.fsmState = 'commandOpenWait4';
        }
        break;
      case 'commandOpenWait4':
        // Detecta início do movimento
        if (
          this.timestamp1 &&
          Date.now() - this.lastEvents.leftRightBlink.timestamp > 4000 &&
          Date.now() - this.lastEvents.leftBlink.timestamp > 4000 &&
          Date.now() - this.lastEvents.rightBlink.timestamp > 4000
        ) {
          // this.ttsService.speakSystem('OK').then(()=>{
          //   this.timestamp1 = Date.now();
          // });
          this.currentParameters.fsmState = 'done';
        }
        if (this.timestamp1 && Date.now() - this.timestamp1 > 6000) {
          // timeout
          // this.commandText = 'OK';
          // this.timestamp1 = undefined;
          // this.ttsService.speakSystem(this.commandText).then(()=>{
          //   this.timestamp1 = Date.now();
          // });
          this.results.leftBlink.score *= 0.6;
          this.currentParameters.fsmState = 'done';
        }
        break;

      case 'done':
        this.capturing = false;
        this.arrow = undefined;
        this.endCurrentTest(true);
        break;
      default:
        break;
    }
  }

  faceEyeGazeTestFsm() { // olhar aquii
    // Skip if eye gaze
    if (
      ['eyeGazeLeft', 'eyeGazeRight', 'eyeGazeUp'].indexOf(this.currentTest) < 0
    ) {
      return;
    }
    // Se o fsmState não estiver definido ou inválido a FSM não faz nada
    switch (this.currentParameters.fsmState) {
      case 'start':
        this.currentParameters.fsmState = 'commandCenter';
        break;

      case 'commandCenter':
        // Detecta início do movimento
        this.commandText =
          'Mantenha sua cabeça centralizada e direcione seu olhar para o centro da tela';
        this.timestamp1 = undefined;
        this.tipImagePath = '/assets/images/MP4/cabeça04GirarEsqCentro.mp4';
        this.voice.speakSystem(this.commandText).then(() => {
          this.timestamp1 = Date.now();
          this.floatingTarget = { x: 50, y: 50 };
        });
        this.currentParameters.fsmState = 'commandCenterWait';
        break;
      case 'commandCenterWait':
        // Detecta início do movimento
        if (
          this.timestamp1 &&
          Date.now() - this.lastEvents.eyeGazeUp.timestamp > 4000 &&
          Date.now() - this.lastEvents.eyeGazeLeft.timestamp > 4000 &&
          Date.now() - this.lastEvents.eyeGazeRight.timestamp > 4000 &&
          Date.now() - this.lastEvents.headPointingAway.timestamp > 2000 &&
          !this.lastEvents.headPointingAway.detected &&
          !(
            this.lastEvents.eyeGazeUp.detected ||
            this.lastEvents.eyeGazeLeft.detected ||
            this.lastEvents.eyeGazeRight.detected
          )
        ) {
          this.voice.speakSystem('perfeito.').then(() => {
            this.timestamp1 = Date.now();
          });
          this.floatingTarget = undefined;
          this.currentParameters.fsmState = 'commandGazeRight';
        }

        // Detects head pointing away from camera

        // // Detecta início do movimento
        // if (this.timestamp1 && (Date.now() - this.timestamp1 > 2000) &&
        //   (Date.now() - this.lastEvents.eyeGazeLeft.timestamp > 4000) && (Date.now() - this.lastEvents.eyeGazeRight.timestamp > 4000)) {
        //   this.ttsService.speakSystem('perfeito.').then(()=>{
        //     this.timestamp1 = Date.now();
        //   });
        //   this.currentParameters.fsmState = 'commandGazeRight';
        // }

        if (this.timestamp1 && Date.now() - this.timestamp1 > 6000) {
          // timeout
          //this.commandText = 'Abra os olhos';
          this.timestamp1 = undefined;
          this.floatingTarget = undefined;
          this.voice.speakSystem(this.commandText).then(() => {
            this.timestamp1 = Date.now();
          });
          this.currentParameters.fsmState = 'commandCenter';
        }
        break;
      case 'commandGazeRight':
        this.commandText = 'Olhe bem para a direita';
        this.timestamp1 = undefined;
        this.tipImagePath = '/assets/images/MP4/olhos21OlharDir.mp4';
        this.updateVideoElement();
        this.voice.speakSystem(this.commandText).then(() => {
          this.timestamp1 = Date.now();
          this.arrow = 0;
        });
        this.currentParameters.fsmState = 'commandRightWait';
        break;
      case 'commandRightWait':
        if (
          this.timestamp1 &&
          Date.now() - this.lastEvents.eyeGazeUp.timestamp > 4000 &&
          Date.now() - this.lastEvents.eyeGazeLeft.timestamp > 4000 &&
          this.lastEvents.eyeGazeRight.detected &&
          //((Date.now() - this.lastEvents.headPointingAway.timestamp > 4000) && !this.lastEvents.headPointingAway.detected) &&
          !(
            this.lastEvents.eyeGazeUp.detected ||
            this.lastEvents.eyeGazeLeft.detected
          )
        ) {
          this.arrow = undefined;
          this.results.eyeGazeRight.score = 1;
          this.results.eyeGazeRight.tested = 'binary';
          this.voice.speakSystem('perfeito.').then(() => {
            this.timestamp1 = Date.now();
          });
          this.currentParameters.fsmState = 'commandGazeLeft';
        }
        if (this.timestamp1 && Date.now() - this.timestamp1 > 6000) {
          // timeout
          // this.commandText = 'Abra os olhos';
          this.timestamp1 = undefined;
          this.arrow = undefined;
          this.results.eyeGazeRight.score = 0.6;
          this.results.eyeGazeRight.tested = 'fail';
          // this.ttsService.speakSystem(this.commandText).then(()=>{
          //   this.timestamp1 = Date.now();
          // });
          this.currentParameters.fsmState = 'commandGazeLeft';
        }
        break;

      case 'commandGazeLeft':
        this.commandText = 'Olhe para a esquerda';
        this.timestamp1 = undefined;
        this.tipImagePath = '/assets/images/MP4/olhos22OlharEsq.mp4';
        this.updateVideoElement();
        this.voice.speakSystem(this.commandText).then(() => {
          this.arrow = 180;
          this.timestamp1 = Date.now();
        });
        this.currentParameters.fsmState = 'commandLeftWait';
        break;
      case 'commandLeftWait':
        if (
          this.timestamp1 &&
          Date.now() - this.lastEvents.eyeGazeUp.timestamp > 4000 &&
          this.lastEvents.eyeGazeLeft.detected &&
          Date.now() - this.lastEvents.eyeGazeRight.timestamp > 4000 &&
          //((Date.now() - this.lastEvents.headPointingAway.timestamp > 4000) && !this.lastEvents.headPointingAway.detected) &&
          !(
            this.lastEvents.eyeGazeUp.detected ||
            this.lastEvents.eyeGazeRight.detected
          )
        ) {
          this.voice.speakSystem('perfeito.').then(() => {
            this.timestamp1 = Date.now();
          });
          this.arrow = undefined;
          this.results.eyeGazeLeft.tested = 'binary';
          this.results.eyeGazeLeft.score = 1;
          this.currentParameters.fsmState = 'commandGazeCenter2';
        }
        if (this.timestamp1 && Date.now() - this.timestamp1 > 8000) {
          // timeout
          this.arrow = undefined;
          this.timestamp1 = undefined;
          this.results.eyeGazeLeft.tested = 'fail';
          this.results.eyeGazeLeft.score = 0.6;
          // this.ttsService.speakSystem(this.commandText).then(()=>{
          //   this.timestamp1 = Date.now();
          // });
          this.currentParameters.fsmState = 'commandGazeCenter2';
        }
        break;

      case 'commandGazeCenter2':
        this.commandText = 'Olhe para o centro da tela';
        this.timestamp1 = undefined;
        this.tipImagePath = '/assets/images/MP4/cabeça04GirarEsqCentro.mp4';
        this.voice.speakSystem(this.commandText).then(() => {
          this.timestamp1 = Date.now();
          this.floatingTarget = { x: 50, y: 50 };
        });
        this.currentParameters.fsmState = 'commandGazeCenter2Wait';
        break;
      case 'commandGazeCenter2Wait':
        if (
          this.timestamp1 &&
          Date.now() - this.lastEvents.eyeGazeUp.timestamp > 4000 &&
          Date.now() - this.lastEvents.eyeGazeLeft.timestamp > 4000 &&
          Date.now() - this.lastEvents.eyeGazeRight.timestamp > 4000 &&
          Date.now() - this.lastEvents.headPointingAway.timestamp > 2000 &&
          !this.lastEvents.headPointingAway.detected &&
          !(
            this.lastEvents.eyeGazeUp.detected ||
            this.lastEvents.eyeGazeLeft.detected ||
            this.lastEvents.eyeGazeRight.detected
          )
        ) {
          this.floatingTarget = undefined;
          this.results.eyeGazeUp.score = 1;
          this.voice.speakSystem('perfeito.').then(() => {
            this.timestamp1 = Date.now();
          });
          this.currentParameters.fsmState = 'commandGazeUp';
        }

        if (this.timestamp1 && Date.now() - this.timestamp1 > 8000) {
          // timeout
          this.commandText = 'Abra os olhos';
          this.timestamp1 = undefined;
          this.floatingTarget = undefined;
          this.results.eyeGazeLeft.score *= 0.8;
          this.results.eyeGazeRight.score *= 0.8;
          this.results.eyeGazeUp.score = 0.8;
          // this.results.leftRightBlink.tested = 'fail';
          // this.ttsService.speakSystem(this.commandText).then(()=>{
          //   this.timestamp1 = Date.now();
          // });
          this.arrow = undefined;
          this.currentParameters.fsmState = 'commandGazeUp';
        }
        break;

      case 'commandGazeUp':
        this.commandText = 'Olhe bem para cima';
        this.timestamp1 = undefined;
        this.tipImagePath = '/assets/images/MP4/olhos19OlharCima.mp4';
        this.updateVideoElement();
        this.voice.speakSystem(this.commandText).then(() => {
          this.arrow = 180;
          this.timestamp1 = Date.now();
        });
        this.currentParameters.fsmState = 'commandGazeUpWait';
        break;
      case 'commandGazeUpWait':
        if (
          this.timestamp1 &&
          this.lastEvents.eyeGazeUp.detected &&
          Date.now() - this.lastEvents.eyeGazeLeft.timestamp > 4000 &&
          Date.now() - this.lastEvents.eyeGazeRight.timestamp > 4000 &&
          //((Date.now() - this.lastEvents.headPointingAway.timestamp > 4000) && !this.lastEvents.headPointingAway.detected) &&
          !(
            this.lastEvents.eyeGazeRight.detected ||
            this.lastEvents.eyeGazeLeft.detected
          )
        ) {
          this.voice.speakSystem('perfeito.').then(() => {
            this.timestamp1 = Date.now();
          });
          this.arrow = undefined;

          this.results.eyeGazeUp.tested = 'binary';
          this.currentParameters.fsmState = 'done';
        }
        if (this.timestamp1 && Date.now() - this.timestamp1 > 8000) {
          // timeout
          this.arrow = undefined;
          this.timestamp1 = undefined;
          this.results.eyeGazeUp.tested = 'fail';
          this.results.eyeGazeUp.score = 0.6;

          this.currentParameters.fsmState = 'done';
        }
        break;

      case 'done':
        this.capturing = false;
        this.arrow = undefined;
        this.endCurrentTest(true);
        break;
      default:
        break;
    }
  }

  // Results
  calculateResult() {
    switch (this.compiledResults.digitalInputs) {
      case 0:
        this.calculateResultP0();
        break;
      case 1:
        this.calculateResultP1();
        break;
      default:
        this.calculateResultP2();
        break;
    }
  }

  calculateResultP0() {
    // Make a copy of the results for destructive processing
    const resultsCopy = JSON.parse(JSON.stringify(this.results)) as MovementTestResults;
    this.suggestedMappings = new Array<MappingsItemSettings>();
    // Selection
    // Eye blink both
    if (resultsCopy.leftRightBlink.tested === 'binary') {
      this.suggestedMappings.push({
        name: 'Blink both to select',
        enabled: true,
        priority: 0,
        movement: {
          name: 'Piscar ambos olhos',
          function: 'findLeftAndRightEyeBlink',
          source: MovementSource.face,
        },
        detectionAction: {
          name: 'Selecionar',
          function: 'actionSelect',
          filterClass: ActionFilterClass.scan,
        },
        rescaleMin: 0,
        rescaleMax: 1,
        detectionThreshold: 0.4,
        hysteresis: 0.1,
        holdTime: 100,
        resolution: 1,
        actionSound: {
          name: 'Bip',
          function: 'tulum',
          filterClass: ActionFilterClass.sound,
        }
      });

      resultsCopy.leftRightBlink.tested = 'untested';
    }
    // Selection
    // Smile
    else if (resultsCopy.smile.tested === 'binary') {
      this.suggestedMappings.push({
        name: 'Smile to select',
        enabled: true,
        priority: 0,
        movement: {
          name: 'Sorriso',
          function: 'findSmile',
          source: MovementSource.face,
        },
        detectionAction: {
          name: 'Selecionar',
          function: 'actionSelect',
          filterClass: ActionFilterClass.scan,
        },
        rescaleMin: 0,
        rescaleMax: 1,
        detectionThreshold: 0.35,
        hysteresis: 0.1,
        holdTime: 100,
        resolution: 1,
        actionSound: {
          name: 'Bip',
          function: 'tulum',
          filterClass: ActionFilterClass.sound,
        }
      });

      resultsCopy.smile.tested = 'untested';
    }
    // Selection
    // Open Mouth
    else if (resultsCopy.mouthOpen.tested === 'binary' || resultsCopy.mouthOpen.tested === 'digital') {
      this.suggestedMappings.push({
        name: 'Open mouth to select',
        enabled: true,
        priority: 0,
        movement: {
          name: 'Open Mouth',
          function: 'findMouthOpen',
          source: MovementSource.face,
        },
        detectionAction: {
          name: 'Selecionar',
          function: 'actionSelect',
          filterClass: ActionFilterClass.scan,
        },
        rescaleMin: 0,
        rescaleMax: 1,
        detectionThreshold: 0.35,
        hysteresis: 0.1,
        holdTime: 100,
        resolution: 1,
        actionSound: {
          name: 'Bip',
          function: 'tulum',
          filterClass: ActionFilterClass.sound,
        }
      });

      resultsCopy.mouthOpen.tested = 'untested';
    }
    // Selection
    // Kiss
    else if (resultsCopy.kiss.tested === 'binary') {
      this.suggestedMappings.push({
        name: 'Kiss to select',
        enabled: true,
        priority: 0,
        movement: {
          name: 'Kiss',
          function: 'findMouthPuck',
          source: MovementSource.face,
        },
        detectionAction: {
          name: 'Selecionar',
          function: 'actionSelect',
          filterClass: ActionFilterClass.scan,
        },
        rescaleMin: 0,
        rescaleMax: 1,
        detectionThreshold: 0.35,
        hysteresis: 0.1,
        holdTime: 100,
        resolution: 1,
        actionSound: {
          name: 'Bip',
          function: 'tulum',
          filterClass: ActionFilterClass.sound,
        }
      });

      resultsCopy.kiss.tested = 'untested';
    }
    // Selection
    // Eye blink right
    else if (resultsCopy.rightBlink.tested === 'binary') {
      this.suggestedMappings.push({
        name: 'Blink right to select',
        enabled: true,
        priority: 0,
        movement: {
          name: 'Piscar olho direito',
          function: 'findRightEyeBlink',
          source: MovementSource.face,
        },
        detectionAction: {
          name: 'Selecionar',
          function: 'actionSelect',
          filterClass: ActionFilterClass.scan,
        },
        rescaleMin: 0,
        rescaleMax: 1,
        detectionThreshold: 0.3,
        hysteresis: 0.1,
        holdTime: 100,
        resolution: 1,
        actionSound: {
          name: 'Bip',
          function: 'tulum',
          filterClass: ActionFilterClass.sound,
        }
      });

      resultsCopy.rightBlink.tested = 'untested';
    }
    // Selection
    // Eye blink right
    else if (resultsCopy.leftBlink.tested === 'binary') {
      this.suggestedMappings.push({
        name: 'Blink left to select',
        enabled: true,
        priority: 0,
        movement: {
          name: 'Piscar olho esquerdo',
          function: 'findRightEyeBlink',
          source: MovementSource.face,
        },
        detectionAction: {
          name: 'Selecionar',
          function: 'actionSelect',
          filterClass: ActionFilterClass.scan,
        },
        rescaleMin: 0,
        rescaleMax: 1,
        detectionThreshold: 0.3,
        hysteresis: 0.1,
        holdTime: 100,
        resolution: 1,
        actionSound: {
          name: 'Bip',
          function: 'tulum',
          filterClass: ActionFilterClass.sound,
        }
      });

      resultsCopy.leftBlink.tested = 'untested';
    }

    // Undo
    // Smile
    if (resultsCopy.smile.tested === 'binary') {
      this.suggestedMappings.push({
        name: 'Smile to select',
        enabled: true,
        priority: 0,
        movement: {
          name: 'Sorriso',
          function: 'findSmile',
          source: MovementSource.face,
        },
        detectionAction: {
          name: 'Desfazer',
          function: 'actionUndo',
          filterClass: ActionFilterClass.scan,
        },
        rescaleMin: 0,
        rescaleMax: 1,
        detectionThreshold: 0.35,
        hysteresis: 0.1,
        holdTime: 100,
        resolution: 1,
        actionSound: {
          name: 'Knock',
          function: 'knock',
          filterClass: ActionFilterClass.sound,
        }
      });

      resultsCopy.smile.tested = 'untested';
    }
    // Undo
    // Open Mouth
    else if (resultsCopy.mouthOpen.tested === 'binary' || resultsCopy.mouthOpen.tested === 'digital') {
      this.suggestedMappings.push({
        name: 'Open mouth to select',
        enabled: true,
        priority: 0,
        movement: {
          name: 'Open Mouth',
          function: 'findMouthOpen',
          source: MovementSource.face,
        },
        detectionAction: {
          name: 'Desfazer',
          function: 'actionUndo',
          filterClass: ActionFilterClass.scan,
        },
        rescaleMin: 0,
        rescaleMax: 1,
        detectionThreshold: 0.35,
        hysteresis: 0.1,
        holdTime: 100,
        resolution: 1,
        actionSound: {
          name: 'Knock',
          function: 'knock',
          filterClass: ActionFilterClass.sound,
        }
      });

      resultsCopy.mouthOpen.tested = 'untested';
    }
    // Undo
    // Kiss
    else if (resultsCopy.kiss.tested === 'binary') {
      this.suggestedMappings.push({
        name: 'Kiss to select',
        enabled: true,
        priority: 0,
        movement: {
          name: 'Kiss',
          function: 'findMouthPuck',
          source: MovementSource.face,
        },
        detectionAction: {
          name: 'Desfazer',
          function: 'actionUndo',
          filterClass: ActionFilterClass.scan,
        },
        rescaleMin: 0,
        rescaleMax: 1,
        detectionThreshold: 0.35,
        hysteresis: 0.1,
        holdTime: 100,
        resolution: 1,
        actionSound: {
          name: 'Knock',
          function: 'knock',
          filterClass: ActionFilterClass.sound,
        }
      });

      resultsCopy.kiss.tested = 'untested';
    }
    // Undo
    // Eye blink right
    if (resultsCopy.rightBlink.tested === 'binary') {
      this.suggestedMappings.push({
        name: 'Blink right to select',
        enabled: true,
        priority: 0,
        movement: {
          name: 'Piscar olho direito',
          function: 'findRightEyeBlink',
          source: MovementSource.face,
        },
        detectionAction: {
          name: 'Desfazer',
          function: 'actionUndo',
          filterClass: ActionFilterClass.scan,
        },
        rescaleMin: 0,
        rescaleMax: 1,
        detectionThreshold: 0.3,
        hysteresis: 0.1,
        holdTime: 100,
        resolution: 1,
        actionSound: {
          name: 'Knock',
          function: 'knock',
          filterClass: ActionFilterClass.sound,
        }
      });

      resultsCopy.rightBlink.tested = 'untested';
    }
    // Undo
    // Eye blink right
    if (resultsCopy.leftBlink.tested === 'binary') {
      this.suggestedMappings.push({
        name: 'Blink left to select',
        enabled: true,
        priority: 0,
        movement: {
          name: 'Piscar olho esquerdo',
          function: 'findRightEyeBlink',
          source: MovementSource.face,
        },
        detectionAction: {
          name: 'Desfazer',
          function: 'actionUndo',
          filterClass: ActionFilterClass.scan,
        },
        rescaleMin: 0,
        rescaleMax: 1,
        detectionThreshold: 0.3,
        hysteresis: 0.1,
        holdTime: 100,
        resolution: 1,
        actionSound: {
          name: 'Knock',
          function: 'knock',
          filterClass: ActionFilterClass.sound,
        }
      });

      resultsCopy.leftBlink.tested = 'untested';
    }

    // Toggle vision

    console.log('[calculateResultP1]', resultsCopy, this.suggestedMappings);
  }

  calculateResultP1() {
    // Make a copy of the results for destructive processing
    const resultsCopy = JSON.parse(JSON.stringify(this.results)) as MovementTestResults;
    this.suggestedMappings = new Array<MappingsItemSettings>();

    // Multidirectional Cursor
    // Head Yaw
    if (resultsCopy.headYaw.tested === 'digital') {
      this.suggestedMappings.push({
        name: 'head yaw cursor HV',
        enabled: true,
        priority: 0,
        movement: {
          name: 'Cabeça: rotação direita-esquerda',
          function: 'findYaw',
          source: MovementSource.face,
        },
        detectionAction: {
          name: 'Cursor Multidirecional',
          function: 'actionCursorHV',
          filterClass: ActionFilterClass.cursorPosition,
        },
        rescaleMin: 0.3,
        rescaleMax: 0.7,
        hysteresis: 0.1,
        resolution: 6,
      });

      resultsCopy.headYaw.tested = 'untested';
    }
    // Multidirectional Cursor
    // Head Pitch
    else if (resultsCopy.headPitch.tested === 'digital') {
      this.suggestedMappings.push({
        name: 'head pitch Cursor Multidirecional',
        enabled: true,
        priority: 0,
        movement: {
          name: 'Cabeça: rotação cima-baixo',
          function: 'findPitch',
          source: MovementSource.face,
        },
        detectionAction: {
          name: 'Cursor Multidirecional',
          function: 'actionCursorHV',
          filterClass: ActionFilterClass.cursorPosition,
        },
        rescaleMin: 0.3,
        rescaleMax: 0.7,
        hysteresis: 0.1,
        resolution: 6,
      });

      resultsCopy.headPitch.tested = 'untested';
    }
    // Multidirectional Cursor
    // Mouth Open
    else if (resultsCopy.mouthOpen.tested === 'digital') {
      this.suggestedMappings.push({
        name: 'Mouse Open Cursor Multidirecional',
        enabled: true,
        priority: 0,
        movement: {
          name: 'Cabeça: rotação cima-baixo',
          function: 'findPitch',
          source: MovementSource.face,
        },
        detectionAction: {
          name: 'Cursor Multidirecional',
          function: 'actionCursorHV',
          filterClass: ActionFilterClass.cursorPosition,
        },
        rescaleMin: 0,
        rescaleMax: 0.9,
        hysteresis: 0.1,
        resolution: 6,
      });

      resultsCopy.mouthOpen.tested = 'untested';
    }
    // Multidirectional Cursor
    // Head Roll
    else if (resultsCopy.headRoll.tested === 'digital') {
      this.suggestedMappings.push({
        name: 'Head Roll Cursor Multidirecional',
        enabled: true,
        priority: 0,
        movement: {
          name: 'Cabeça: rotação cima-baixo',
          function: 'findRoll',
          source: MovementSource.face,
        },
        detectionAction: {
          name: 'Cursor Multidirecional',
          function: 'actionCursorHV',
          filterClass: ActionFilterClass.cursorPosition,
        },
        rescaleMin: 0.3,
        rescaleMax: 0.7,
        hysteresis: 0.1,
        resolution: 6,
      });

      resultsCopy.headRoll.tested = 'untested';
    }

    // Selection
    // Eye blink both
    if (resultsCopy.leftRightBlink.tested === 'binary') {
      this.suggestedMappings.push({
        name: 'Blink both to select',
        enabled: true,
        priority: 0,
        movement: {
          name: 'Piscar ambos olhos',
          function: 'findLeftAndRightEyeBlink',
          source: MovementSource.face,
        },
        detectionAction: {
          name: 'Selecionar',
          function: 'actionSelect',
          filterClass: ActionFilterClass.scan,
        },
        rescaleMin: 0,
        rescaleMax: 1,
        detectionThreshold: 0.4,
        hysteresis: 0.1,
        holdTime: 100,
        resolution: 1,
        actionSound: {
          name: 'Bip',
          function: 'tulum',
          filterClass: ActionFilterClass.sound,
        }
      });

      resultsCopy.leftRightBlink.tested = 'untested';
    }
    // Selection
    // Smile
    else if (resultsCopy.smile.tested === 'binary') {
      this.suggestedMappings.push({
        name: 'Smile to select',
        enabled: true,
        priority: 0,
        movement: {
          name: 'Sorriso',
          function: 'findSmile',
          source: MovementSource.face,
        },
        detectionAction: {
          name: 'Selecionar',
          function: 'actionSelect',
          filterClass: ActionFilterClass.scan,
        },
        rescaleMin: 0,
        rescaleMax: 1,
        detectionThreshold: 0.35,
        hysteresis: 0.1,
        holdTime: 100,
        resolution: 1,
        actionSound: {
          name: 'Bip',
          function: 'tulum',
          filterClass: ActionFilterClass.sound,
        }
      });

      resultsCopy.smile.tested = 'untested';
    }
    // Selection
    // Open Mouth
    else if (resultsCopy.mouthOpen.tested === 'binary' || resultsCopy.mouthOpen.tested === 'digital') {
      this.suggestedMappings.push({
        name: 'Open mouth to select',
        enabled: true,
        priority: 0,
        movement: {
          name: 'Open Mouth',
          function: 'findMouthOpen',
          source: MovementSource.face,
        },
        detectionAction: {
          name: 'Selecionar',
          function: 'actionSelect',
          filterClass: ActionFilterClass.scan,
        },
        rescaleMin: 0,
        rescaleMax: 1,
        detectionThreshold: 0.35,
        hysteresis: 0.1,
        holdTime: 100,
        resolution: 1,
        actionSound: {
          name: 'Bip',
          function: 'tulum',
          filterClass: ActionFilterClass.sound,
        }
      });

      resultsCopy.mouthOpen.tested = 'untested';
    }
    // Selection
    // Kiss
    else if (resultsCopy.kiss.tested === 'binary') {
      this.suggestedMappings.push({
        name: 'Kiss to select',
        enabled: true,
        priority: 0,
        movement: {
          name: 'Kiss',
          function: 'findMouthPuck',
          source: MovementSource.face,
        },
        detectionAction: {
          name: 'Selecionar',
          function: 'actionSelect',
          filterClass: ActionFilterClass.scan,
        },
        rescaleMin: 0,
        rescaleMax: 1,
        detectionThreshold: 0.35,
        hysteresis: 0.1,
        holdTime: 100,
        resolution: 1,
        actionSound: {
          name: 'Bip',
          function: 'tulum',
          filterClass: ActionFilterClass.sound,
        }
      });

      resultsCopy.kiss.tested = 'untested';
    }
    // Selection
    // Eye blink right
    else if (resultsCopy.rightBlink.tested === 'binary') {
      this.suggestedMappings.push({
        name: 'Blink right to select',
        enabled: true,
        priority: 0,
        movement: {
          name: 'Piscar olho direito',
          function: 'findRightEyeBlink',
          source: MovementSource.face,
        },
        detectionAction: {
          name: 'Selecionar',
          function: 'actionSelect',
          filterClass: ActionFilterClass.scan,
        },
        rescaleMin: 0,
        rescaleMax: 1,
        detectionThreshold: 0.3,
        hysteresis: 0.1,
        holdTime: 100,
        resolution: 1,
        actionSound: {
          name: 'Bip',
          function: 'tulum',
          filterClass: ActionFilterClass.sound,
        }
      });

      resultsCopy.rightBlink.tested = 'untested';
    }
    // Selection
    // Eye blink right
    else if (resultsCopy.leftBlink.tested === 'binary') {
      this.suggestedMappings.push({
        name: 'Blink left to select',
        enabled: true,
        priority: 0,
        movement: {
          name: 'Piscar olho esquerdo',
          function: 'findRightEyeBlink',
          source: MovementSource.face,
        },
        detectionAction: {
          name: 'Selecionar',
          function: 'actionSelect',
          filterClass: ActionFilterClass.scan,
        },
        rescaleMin: 0,
        rescaleMax: 1,
        detectionThreshold: 0.3,
        hysteresis: 0.1,
        holdTime: 100,
        resolution: 1,
        actionSound: {
          name: 'Bip',
          function: 'tulum',
          filterClass: ActionFilterClass.sound,
        }
      });

      resultsCopy.leftBlink.tested = 'untested';
    }

    // Undo
    // Smile
    if (resultsCopy.smile.tested === 'binary') {
      this.suggestedMappings.push({
        name: 'Smile to select',
        enabled: true,
        priority: 0,
        movement: {
          name: 'Sorriso',
          function: 'findSmile',
          source: MovementSource.face,
        },
        detectionAction: {
          name: 'Desfazer',
          function: 'actionUndo',
          filterClass: ActionFilterClass.scan,
        },
        rescaleMin: 0,
        rescaleMax: 1,
        detectionThreshold: 0.35,
        hysteresis: 0.1,
        holdTime: 100,
        resolution: 1,
        actionSound: {
          name: 'Knock',
          function: 'knock',
          filterClass: ActionFilterClass.sound,
        }
      });

      resultsCopy.smile.tested = 'untested';
    }
    // Undo
    // Open Mouth
    else if (resultsCopy.mouthOpen.tested === 'binary' || resultsCopy.mouthOpen.tested === 'digital') {
      this.suggestedMappings.push({
        name: 'Open mouth to select',
        enabled: true,
        priority: 0,
        movement: {
          name: 'Open Mouth',
          function: 'findMouthOpen',
          source: MovementSource.face,
        },
        detectionAction: {
          name: 'Desfazer',
          function: 'actionUndo',
          filterClass: ActionFilterClass.scan,
        },
        rescaleMin: 0,
        rescaleMax: 1,
        detectionThreshold: 0.35,
        hysteresis: 0.1,
        holdTime: 100,
        resolution: 1,
        actionSound: {
          name: 'Knock',
          function: 'knock',
          filterClass: ActionFilterClass.sound,
        }
      });

      resultsCopy.mouthOpen.tested = 'untested';
    }
    // Undo
    // Kiss
    else if (resultsCopy.kiss.tested === 'binary') {
      this.suggestedMappings.push({
        name: 'Kiss to select',
        enabled: true,
        priority: 0,
        movement: {
          name: 'Kiss',
          function: 'findMouthPuck',
          source: MovementSource.face,
        },
        detectionAction: {
          name: 'Desfazer',
          function: 'actionUndo',
          filterClass: ActionFilterClass.scan,
        },
        rescaleMin: 0,
        rescaleMax: 1,
        detectionThreshold: 0.35,
        hysteresis: 0.1,
        holdTime: 100,
        resolution: 1,
        actionSound: {
          name: 'Knock',
          function: 'knock',
          filterClass: ActionFilterClass.sound,
        }
      });

      resultsCopy.kiss.tested = 'untested';
    }
    // Undo
    // Eye blink right
    if (resultsCopy.rightBlink.tested === 'binary') {
      this.suggestedMappings.push({
        name: 'Blink right to select',
        enabled: true,
        priority: 0,
        movement: {
          name: 'Piscar olho direito',
          function: 'findRightEyeBlink',
          source: MovementSource.face,
        },
        detectionAction: {
          name: 'Desfazer',
          function: 'actionUndo',
          filterClass: ActionFilterClass.scan,
        },
        rescaleMin: 0,
        rescaleMax: 1,
        detectionThreshold: 0.3,
        hysteresis: 0.1,
        holdTime: 100,
        resolution: 1,
        actionSound: {
          name: 'Knock',
          function: 'knock',
          filterClass: ActionFilterClass.sound,
        }
      });

      resultsCopy.rightBlink.tested = 'untested';
    }
    // Undo
    // Eye blink right
    if (resultsCopy.leftBlink.tested === 'binary') {
      this.suggestedMappings.push({
        name: 'Blink left to select',
        enabled: true,
        priority: 0,
        movement: {
          name: 'Piscar olho esquerdo',
          function: 'findRightEyeBlink',
          source: MovementSource.face,
        },
        detectionAction: {
          name: 'Desfazer',
          function: 'actionUndo',
          filterClass: ActionFilterClass.scan,
        },
        rescaleMin: 0,
        rescaleMax: 1,
        detectionThreshold: 0.3,
        hysteresis: 0.1,
        holdTime: 100,
        resolution: 1,
        actionSound: {
          name: 'Knock',
          function: 'knock',
          filterClass: ActionFilterClass.sound,
        }
      });

      resultsCopy.leftBlink.tested = 'untested';
    }

    // Toggle vision

    console.log('[calculateResultP1]', resultsCopy, this.suggestedMappings);
  }

  calculateResultP2() {
    // Make a copy of the results for destructive processing
    const resultsCopy = JSON.parse(JSON.stringify(this.results)) as MovementTestResults;
    this.suggestedMappings = new Array<MappingsItemSettings>();

    // Cursor H
    // Head Yaw
    if (resultsCopy.headYaw.tested === 'digital') {
      this.suggestedMappings.push({
        name: 'head yaw cursor H',
        enabled: true,
        priority: 0,
        movement: {
          name: 'Cabeça: rotação direita-esquerda',
          function: 'findYaw',
          source: MovementSource.face,
        },
        detectionAction: {
          name: 'Cursor Horizontal',
          function: 'actionCursorH',
          filterClass: ActionFilterClass.cursorPosition,
        },
        rescaleMin: 0.3,
        rescaleMax: 0.7,
        hysteresis: 0.1,
        resolution: 6,
      });

      resultsCopy.headYaw.tested = 'untested';
    }
    // Cursor H
    // Head Roll
    else if (resultsCopy.headRoll.tested === 'digital') {
      this.suggestedMappings.push({
        name: 'Head Roll cursor H',
        enabled: true,
        priority: 0,
        movement: {
          name: 'Cabeça: rotação cima-baixo',
          function: 'findRoll',
          source: MovementSource.face,
        },
        detectionAction: {
          name: 'Cursor Horizontal',
          function: 'actionCursorH',
          filterClass: ActionFilterClass.cursorPosition,
        },
        rescaleMin: 0.3,
        rescaleMax: 0.7,
        hysteresis: 0.1,
        resolution: 6,
      });

      resultsCopy.headRoll.tested = 'untested';
    }

    // Cursor V
    // Head Pitch
    if (resultsCopy.headPitch.tested === 'digital') {
      this.suggestedMappings.push({
        name: 'head pitch cursor Vertical',
        enabled: true,
        priority: 0,
        movement: {
          name: 'Cabeça: rotação cima-baixo',
          function: 'findPitch',
          source: MovementSource.face,
        },
        detectionAction: {
          name: 'Cursor Vertical',
          function: 'actionCursorV',
          filterClass: ActionFilterClass.cursorPosition,
        },
        rescaleMin: 0.3,
        rescaleMax: 0.7,
        hysteresis: 0.1,
        resolution: 6,
      });

      resultsCopy.headPitch.tested = 'untested';
    }
    // Multidirectional Cursor
    // Mouth Open
    else if (resultsCopy.mouthOpen.tested === 'digital') {
      this.suggestedMappings.push({
        name: 'Mouse Open cursor Vertical',
        enabled: true,
        priority: 0,
        movement: {
          name: 'Cabeça: rotação cima-baixo',
          function: 'findPitch',
          source: MovementSource.face,
        },
        detectionAction: {
          name: 'Cursor Vertical',
          function: 'actionCursorV',
          filterClass: ActionFilterClass.cursorPosition,
        },
        rescaleMin: 0,
        rescaleMax: 0.9,
        hysteresis: 0.1,
        resolution: 6,
      });

      resultsCopy.mouthOpen.tested = 'untested';
    }

    // Selection
    // Eye blink both
    if (resultsCopy.leftRightBlink.tested === 'binary') {
      this.suggestedMappings.push({
        name: 'Blink both to select',
        enabled: true,
        priority: 0,
        movement: {
          name: 'Piscar ambos olhos',
          function: 'findLeftAndRightEyeBlink',
          source: MovementSource.face,
        },
        detectionAction: {
          name: 'Selecionar',
          function: 'actionSelect',
          filterClass: ActionFilterClass.scan,
        },
        rescaleMin: 0,
        rescaleMax: 1,
        detectionThreshold: 0.4,
        hysteresis: 0.1,
        holdTime: 100,
        resolution: 1,
        actionSound: {
          name: 'Bip',
          function: 'tulum',
          filterClass: ActionFilterClass.sound,
        }
      });

      resultsCopy.leftRightBlink.tested = 'untested';
    }
    // Selection
    // Smile
    else if (resultsCopy.smile.tested === 'binary') {
      this.suggestedMappings.push({
        name: 'Smile to select',
        enabled: true,
        priority: 0,
        movement: {
          name: 'Sorriso',
          function: 'findSmile',
          source: MovementSource.face,
        },
        detectionAction: {
          name: 'Selecionar',
          function: 'actionSelect',
          filterClass: ActionFilterClass.scan,
        },
        rescaleMin: 0,
        rescaleMax: 1,
        detectionThreshold: 0.35,
        hysteresis: 0.1,
        holdTime: 100,
        resolution: 1,
        actionSound: {
          name: 'Bip',
          function: 'tulum',
          filterClass: ActionFilterClass.sound,
        }
      });

      resultsCopy.smile.tested = 'untested';
    }
    // Selection
    // Open Mouth
    else if (resultsCopy.mouthOpen.tested === 'binary' || resultsCopy.mouthOpen.tested === 'digital') {
      this.suggestedMappings.push({
        name: 'Open mouth to select',
        enabled: true,
        priority: 0,
        movement: {
          name: 'Open Mouth',
          function: 'findMouthOpen',
          source: MovementSource.face,
        },
        detectionAction: {
          name: 'Selecionar',
          function: 'actionSelect',
          filterClass: ActionFilterClass.scan,
        },
        rescaleMin: 0,
        rescaleMax: 1,
        detectionThreshold: 0.35,
        hysteresis: 0.1,
        holdTime: 100,
        resolution: 1,
        actionSound: {
          name: 'Bip',
          function: 'tulum',
          filterClass: ActionFilterClass.sound,
        }
      });

      resultsCopy.mouthOpen.tested = 'untested';
    }
    // Selection
    // Kiss
    else if (resultsCopy.kiss.tested === 'binary') {
      this.suggestedMappings.push({
        name: 'Kiss to select',
        enabled: true,
        priority: 0,
        movement: {
          name: 'Kiss',
          function: 'findMouthPuck',
          source: MovementSource.face,
        },
        detectionAction: {
          name: 'Selecionar',
          function: 'actionSelect',
          filterClass: ActionFilterClass.scan,
        },
        rescaleMin: 0,
        rescaleMax: 1,
        detectionThreshold: 0.35,
        hysteresis: 0.1,
        holdTime: 100,
        resolution: 1,
        actionSound: {
          name: 'Bip',
          function: 'tulum',
          filterClass: ActionFilterClass.sound,
        }
      });

      resultsCopy.kiss.tested = 'untested';
    }
    // Selection
    // Eye blink right
    else if (resultsCopy.rightBlink.tested === 'binary') {
      this.suggestedMappings.push({
        name: 'Blink right to select',
        enabled: true,
        priority: 0,
        movement: {
          name: 'Piscar olho direito',
          function: 'findRightEyeBlink',
          source: MovementSource.face,
        },
        detectionAction: {
          name: 'Selecionar',
          function: 'actionSelect',
          filterClass: ActionFilterClass.scan,
        },
        rescaleMin: 0,
        rescaleMax: 1,
        detectionThreshold: 0.3,
        hysteresis: 0.1,
        holdTime: 100,
        resolution: 1,
        actionSound: {
          name: 'Bip',
          function: 'tulum',
          filterClass: ActionFilterClass.sound,
        }
      });

      resultsCopy.rightBlink.tested = 'untested';
    }
    // Selection
    // Eye blink right
    else if (resultsCopy.leftBlink.tested === 'binary') {
      this.suggestedMappings.push({
        name: 'Blink left to select',
        enabled: true,
        priority: 0,
        movement: {
          name: 'Piscar olho esquerdo',
          function: 'findRightEyeBlink',
          source: MovementSource.face,
        },
        detectionAction: {
          name: 'Selecionar',
          function: 'actionSelect',
          filterClass: ActionFilterClass.scan,
        },
        rescaleMin: 0,
        rescaleMax: 1,
        detectionThreshold: 0.3,
        hysteresis: 0.1,
        holdTime: 100,
        resolution: 1,
        actionSound: {
          name: 'Bip',
          function: 'tulum',
          filterClass: ActionFilterClass.sound,
        }
      });

      resultsCopy.leftBlink.tested = 'untested';
    }

    // Undo
    // Smile
    if (resultsCopy.smile.tested === 'binary') {
      this.suggestedMappings.push({
        name: 'Smile to select',
        enabled: true,
        priority: 0,
        movement: {
          name: 'Sorriso',
          function: 'findSmile',
          source: MovementSource.face,
        },
        detectionAction: {
          name: 'Desfazer',
          function: 'actionUndo',
          filterClass: ActionFilterClass.scan,
        },
        rescaleMin: 0,
        rescaleMax: 1,
        detectionThreshold: 0.35,
        hysteresis: 0.1,
        holdTime: 100,
        resolution: 1,
        actionSound: {
          name: 'Knock',
          function: 'knock',
          filterClass: ActionFilterClass.sound,
        }
      });

      resultsCopy.smile.tested = 'untested';
    }
    // Undo
    // Open Mouth
    else if (resultsCopy.mouthOpen.tested === 'binary' || resultsCopy.mouthOpen.tested === 'digital') {
      this.suggestedMappings.push({
        name: 'Open mouth to select',
        enabled: true,
        priority: 0,
        movement: {
          name: 'Open Mouth',
          function: 'findMouthOpen',
          source: MovementSource.face,
        },
        detectionAction: {
          name: 'Desfazer',
          function: 'actionUndo',
          filterClass: ActionFilterClass.scan,
        },
        rescaleMin: 0,
        rescaleMax: 1,
        detectionThreshold: 0.35,
        hysteresis: 0.1,
        holdTime: 100,
        resolution: 1,
        actionSound: {
          name: 'Knock',
          function: 'knock',
          filterClass: ActionFilterClass.sound,
        }
      });

      resultsCopy.mouthOpen.tested = 'untested';
    }
    // Undo
    // Kiss
    else if (resultsCopy.kiss.tested === 'binary') {
      this.suggestedMappings.push({
        name: 'Kiss to select',
        enabled: true,
        priority: 0,
        movement: {
          name: 'Kiss',
          function: 'findMouthPuck',
          source: MovementSource.face,
        },
        detectionAction: {
          name: 'Desfazer',
          function: 'actionUndo',
          filterClass: ActionFilterClass.scan,
        },
        rescaleMin: 0,
        rescaleMax: 1,
        detectionThreshold: 0.35,
        hysteresis: 0.1,
        holdTime: 100,
        resolution: 1,
        actionSound: {
          name: 'Knock',
          function: 'knock',
          filterClass: ActionFilterClass.sound,
        }
      });

      resultsCopy.kiss.tested = 'untested';
    }
    // Undo
    // Eye blink right
    if (resultsCopy.rightBlink.tested === 'binary') {
      this.suggestedMappings.push({
        name: 'Blink right to select',
        enabled: true,
        priority: 0,
        movement: {
          name: 'Piscar olho direito',
          function: 'findRightEyeBlink',
          source: MovementSource.face,
        },
        detectionAction: {
          name: 'Desfazer',
          function: 'actionUndo',
          filterClass: ActionFilterClass.scan,
        },
        rescaleMin: 0,
        rescaleMax: 1,
        detectionThreshold: 0.3,
        hysteresis: 0.1,
        holdTime: 100,
        resolution: 1,
        actionSound: {
          name: 'Knock',
          function: 'knock',
          filterClass: ActionFilterClass.sound,
        }
      });

      resultsCopy.rightBlink.tested = 'untested';
    }
    // Undo
    // Eye blink right
    if (resultsCopy.leftBlink.tested === 'binary') {
      this.suggestedMappings.push({
        name: 'Blink left to select',
        enabled: true,
        priority: 0,
        movement: {
          name: 'Piscar olho esquerdo',
          function: 'findRightEyeBlink',
          source: MovementSource.face,
        },
        detectionAction: {
          name: 'Desfazer',
          function: 'actionUndo',
          filterClass: ActionFilterClass.scan,
        },
        rescaleMin: 0,
        rescaleMax: 1,
        detectionThreshold: 0.3,
        hysteresis: 0.1,
        holdTime: 100,
        resolution: 1,
        actionSound: {
          name: 'Knock',
          function: 'knock',
          filterClass: ActionFilterClass.sound,
        }
      });

      resultsCopy.leftBlink.tested = 'untested';
    }

    // Toggle vision

    console.log('[calculateResultP1]', resultsCopy, this.suggestedMappings);
  }
}
